import { emptySplitApi as api } from "./emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAcronymsUsingGet: build.query<
      GetAcronymsUsingGetApiResponse,
      GetAcronymsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/acronyms`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          searchQuery: queryArg.searchQuery,
        },
      }),
    }),
    createAcronymUsingPost: build.mutation<
      CreateAcronymUsingPostApiResponse,
      CreateAcronymUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/acronyms`,
        method: "POST",
        body: queryArg.acronymCreateDto,
      }),
    }),
    deleteAcronymUsingDelete: build.mutation<
      DeleteAcronymUsingDeleteApiResponse,
      DeleteAcronymUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/acronyms/${queryArg.acronymId}`,
        method: "DELETE",
      }),
    }),
    getAcronymUsingGet: build.query<
      GetAcronymUsingGetApiResponse,
      GetAcronymUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/acronyms/${queryArg.acronymId}` }),
    }),
    updateAcronymUsingPut: build.mutation<
      UpdateAcronymUsingPutApiResponse,
      UpdateAcronymUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/acronyms/${queryArg.acronymId}`,
        method: "PUT",
        body: queryArg.acronymUpdateDto,
      }),
    }),
    getAuditLogsUsingGet: build.query<
      GetAuditLogsUsingGetApiResponse,
      GetAuditLogsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/audit/${queryArg.entityType}/${queryArg.entityId}`,
      }),
    }),
    getAllBusinessDomainsUsingGet: build.query<
      GetAllBusinessDomainsUsingGetApiResponse,
      GetAllBusinessDomainsUsingGetApiArg
    >({
      query: () => ({ url: `/business-domains` }),
    }),
    createBusinessDomainUsingPost: build.mutation<
      CreateBusinessDomainUsingPostApiResponse,
      CreateBusinessDomainUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/business-domains`,
        method: "POST",
        body: queryArg.businessDomainDto,
      }),
    }),
    getAllBusinessDomainsForComboUsingGet: build.query<
      GetAllBusinessDomainsForComboUsingGetApiResponse,
      GetAllBusinessDomainsForComboUsingGetApiArg
    >({
      query: () => ({ url: `/business-domains/combo` }),
    }),
    deleteBusinessDomainUsingDelete: build.mutation<
      DeleteBusinessDomainUsingDeleteApiResponse,
      DeleteBusinessDomainUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/business-domains/${queryArg.businessDomainId}`,
        method: "DELETE",
      }),
    }),
    getBusinessDomainUsingGet: build.query<
      GetBusinessDomainUsingGetApiResponse,
      GetBusinessDomainUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/business-domains/${queryArg.businessDomainId}`,
      }),
    }),
    updateBusinessDomainUsingPut: build.mutation<
      UpdateBusinessDomainUsingPutApiResponse,
      UpdateBusinessDomainUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/business-domains/${queryArg.businessDomainId}`,
        method: "PUT",
        body: queryArg.businessDomainDto,
      }),
    }),
    getCompanyUsingGet: build.query<
      GetCompanyUsingGetApiResponse,
      GetCompanyUsingGetApiArg
    >({
      query: () => ({ url: `/company` }),
    }),
    getAllCustomAttributeStructureTypeDtoUsingGet: build.query<
      GetAllCustomAttributeStructureTypeDtoUsingGetApiResponse,
      GetAllCustomAttributeStructureTypeDtoUsingGetApiArg
    >({
      query: () => ({ url: `/custom-attribute-structure-types` }),
    }),
    getAllCustomAttributesUsingGet: build.query<
      GetAllCustomAttributesUsingGetApiResponse,
      GetAllCustomAttributesUsingGetApiArg
    >({
      query: () => ({ url: `/custom-attributes` }),
    }),
    createCustomAttributeUsingPost: build.mutation<
      CreateCustomAttributeUsingPostApiResponse,
      CreateCustomAttributeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-attributes`,
        method: "POST",
        body: queryArg.customAttributeCreateDto,
      }),
    }),
    getAllCustomAttributesForComboUsingGet: build.query<
      GetAllCustomAttributesForComboUsingGetApiResponse,
      GetAllCustomAttributesForComboUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-attributes/combo/${queryArg.structureType}`,
      }),
    }),
    deleteCustomAttributeUsingDelete: build.mutation<
      DeleteCustomAttributeUsingDeleteApiResponse,
      DeleteCustomAttributeUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-attributes/${queryArg.customAttributeId}`,
        method: "DELETE",
      }),
    }),
    getCustomAttributeUsingGet: build.query<
      GetCustomAttributeUsingGetApiResponse,
      GetCustomAttributeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-attributes/${queryArg.customAttributeId}`,
      }),
    }),
    updateCustomAttributeUsingPut: build.mutation<
      UpdateCustomAttributeUsingPutApiResponse,
      UpdateCustomAttributeUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-attributes/${queryArg.customAttributeId}`,
        method: "PUT",
        body: queryArg.customAttributeUpdateDto,
      }),
    }),
    getAllCustomLovsUsingGet: build.query<
      GetAllCustomLovsUsingGetApiResponse,
      GetAllCustomLovsUsingGetApiArg
    >({
      query: () => ({ url: `/custom-lov` }),
    }),
    createCustomLovUsingPost: build.mutation<
      CreateCustomLovUsingPostApiResponse,
      CreateCustomLovUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-lov`,
        method: "POST",
        body: queryArg.customLovCreateDto,
      }),
    }),
    getAllCustomLovForComboUsingGet: build.query<
      GetAllCustomLovForComboUsingGetApiResponse,
      GetAllCustomLovForComboUsingGetApiArg
    >({
      query: () => ({ url: `/custom-lov/combo` }),
    }),
    deleteCustomLovUsingDelete: build.mutation<
      DeleteCustomLovUsingDeleteApiResponse,
      DeleteCustomLovUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-lov/${queryArg.customLovId}`,
        method: "DELETE",
      }),
    }),
    getCustomLovUsingGet: build.query<
      GetCustomLovUsingGetApiResponse,
      GetCustomLovUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/custom-lov/${queryArg.customLovId}` }),
    }),
    updateCustomLovUsingPut: build.mutation<
      UpdateCustomLovUsingPutApiResponse,
      UpdateCustomLovUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-lov/${queryArg.customLovId}`,
        method: "PUT",
        body: queryArg.customLovUpdateDto,
      }),
    }),
    getCustomLovForComboByIdUsingGet: build.query<
      GetCustomLovForComboByIdUsingGetApiResponse,
      GetCustomLovForComboByIdUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/custom-lov/${queryArg.customLovId}/combo`,
      }),
    }),
    getAllNodeDeploymentsUsingGet: build.query<
      GetAllNodeDeploymentsUsingGetApiResponse,
      GetAllNodeDeploymentsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/deployments/structure/${queryArg.structureId}`,
        params: {
          sqlType: queryArg.sqlType,
        },
      }),
    }),
    getAllSpDeploymentsUsingGet: build.query<
      GetAllSpDeploymentsUsingGetApiResponse,
      GetAllSpDeploymentsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/deployments/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectTypeId}`,
      }),
    }),
    createDeployUsingPost: build.mutation<
      CreateDeployUsingPostApiResponse,
      CreateDeployUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/deployments/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectTypeId}`,
        method: "POST",
        body: queryArg.deploymentNewDto,
      }),
    }),
    getDeploymentDetailUsingGet: build.query<
      GetDeploymentDetailUsingGetApiResponse,
      GetDeploymentDetailUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/deployments/${queryArg.deploymentId}` }),
    }),
    getAllDomainsUsingGet: build.query<
      GetAllDomainsUsingGetApiResponse,
      GetAllDomainsUsingGetApiArg
    >({
      query: () => ({ url: `/domains` }),
    }),
    createDomainUsingPost: build.mutation<
      CreateDomainUsingPostApiResponse,
      CreateDomainUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/domains`,
        method: "POST",
        body: queryArg.domainCreateDto,
      }),
    }),
    getAllDomainsForComboUsingGet: build.query<
      GetAllDomainsForComboUsingGetApiResponse,
      GetAllDomainsForComboUsingGetApiArg
    >({
      query: () => ({ url: `/domains/combo` }),
    }),
    getAllDomainsFilteredBySystemTechnologyUsingGet: build.query<
      GetAllDomainsFilteredBySystemTechnologyUsingGetApiResponse,
      GetAllDomainsFilteredBySystemTechnologyUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/domains/system/${queryArg.systemStructureId}`,
      }),
    }),
    deleteDomainUsingDelete: build.mutation<
      DeleteDomainUsingDeleteApiResponse,
      DeleteDomainUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/domains/${queryArg.domainId}`,
        method: "DELETE",
      }),
    }),
    getAllDomainsFilteredBySystemTechnologyDepUsingGet: build.query<
      GetAllDomainsFilteredBySystemTechnologyDepUsingGetApiResponse,
      GetAllDomainsFilteredBySystemTechnologyDepUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/domains/${queryArg.domainId}` }),
    }),
    updateDomainUsingPut: build.mutation<
      UpdateDomainUsingPutApiResponse,
      UpdateDomainUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/domains/${queryArg.domainId}`,
        method: "PUT",
        body: queryArg.domainUpdateDto,
        params: {
          updateElements: queryArg.updateElements,
        },
      }),
    }),
    getColumnsByDomainUsingGet: build.query<
      GetColumnsByDomainUsingGetApiResponse,
      GetColumnsByDomainUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/domains/${queryArg.domainId}/column` }),
    }),
    getColumnsByDomainCsvUsingGet: build.query<
      GetColumnsByDomainCsvUsingGetApiResponse,
      GetColumnsByDomainCsvUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/domains/${queryArg.domainId}/column/csv`,
      }),
    }),
    computeImpactDomainChangeUsingPost: build.mutation<
      ComputeImpactDomainChangeUsingPostApiResponse,
      ComputeImpactDomainChangeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/domains/${queryArg.domainId}/impact`,
        method: "POST",
        body: queryArg.domainUpdateDto,
      }),
    }),
    getEnvironmentsUsingGet: build.query<
      GetEnvironmentsUsingGetApiResponse,
      GetEnvironmentsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/environments/structure/${queryArg.structureId}`,
      }),
    }),
    getEnvironmentsWithLastDeploymentUsingGet: build.query<
      GetEnvironmentsWithLastDeploymentUsingGetApiResponse,
      GetEnvironmentsWithLastDeploymentUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/environments/structure/${queryArg.structureId}/deployments`,
      }),
    }),
    getEnvironmentsWithLastDeploymentPerObjectTypeUsingGet: build.query<
      GetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetApiResponse,
      GetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/environments/structure/${queryArg.structureId}/deploymentsWithObjectType`,
      }),
    }),
    getEnvironmentByIdUsingGet: build.query<
      GetEnvironmentByIdUsingGetApiResponse,
      GetEnvironmentByIdUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/environments/${queryArg.environmentId}` }),
    }),
    checkFileUsingPost: build.mutation<
      CheckFileUsingPostApiResponse,
      CheckFileUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/import/check-file`,
        method: "POST",
        body: queryArg.body,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    checkJsonUsingPost: build.mutation<
      CheckJsonUsingPostApiResponse,
      CheckJsonUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/import/check-json`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    importFileUsingPost: build.mutation<
      ImportFileUsingPostApiResponse,
      ImportFileUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/import/file`,
        method: "POST",
        body: queryArg.body,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    importStructuresUsingPost: build.mutation<
      ImportStructuresUsingPostApiResponse,
      ImportStructuresUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/import/json`,
        method: "POST",
        body: queryArg.structureExportDto,
        params: {
          parentId: queryArg.parentId,
          existingElementsMode: queryArg.existingElementsMode,
          createDomains: queryArg.createDomains,
          ignoreDomainDuplicities: queryArg.ignoreDomainDuplicities,
          createStereotypes: queryArg.createStereotypes,
          ignoreMissingBO: queryArg.ignoreMissingBo,
          ignoreMissingObjectTypes: queryArg.ignoreMissingObjectTypes,
          ignoreTechnicalColumnCollision:
            queryArg.ignoreTechnicalColumnCollision,
          ignoreInconsistentDomain: queryArg.ignoreInconsistentDomain,
          fkMissingTable: queryArg.fkMissingTable,
          fkMoreTables: queryArg.fkMoreTables,
          detailReport: queryArg.detailReport,
        },
      }),
    }),
    getInitInfoUsingGet: build.query<
      GetInitInfoUsingGetApiResponse,
      GetInitInfoUsingGetApiArg
    >({
      query: () => ({ url: `/init` }),
    }),
    syncRolesUsingPost: build.mutation<
      SyncRolesUsingPostApiResponse,
      SyncRolesUsingPostApiArg
    >({
      query: () => ({ url: `/mgmt/sync-roles`, method: "POST" }),
    }),
    syncSupportUsersUsingPost: build.mutation<
      SyncSupportUsersUsingPostApiResponse,
      SyncSupportUsersUsingPostApiArg
    >({
      query: () => ({ url: `/mgmt/sync-support-users`, method: "POST" }),
    }),
    mgmtCreateTenantUsingPost: build.mutation<
      MgmtCreateTenantUsingPostApiResponse,
      MgmtCreateTenantUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}`,
        method: "POST",
      }),
    }),
    getAllAcronymsUsingGet: build.query<
      GetAllAcronymsUsingGetApiResponse,
      GetAllAcronymsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/acronym`,
      }),
    }),
    importAcronymsFromFileUsingPostUsingPost: build.mutation<
      ImportAcronymsFromFileUsingPostUsingPostApiResponse,
      ImportAcronymsFromFileUsingPostUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/acronym`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getCodeListUsingGet: build.query<
      GetCodeListUsingGetApiResponse,
      GetCodeListUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/code-list`,
        params: {
          codeListType: queryArg.codeListType,
        },
      }),
    }),
    importCodeListUsingPostUsingPost: build.mutation<
      ImportCodeListUsingPostUsingPostApiResponse,
      ImportCodeListUsingPostUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/code-list`,
        method: "POST",
        body: queryArg.codeList,
        params: {
          codeListType: queryArg.codeListType,
        },
      }),
    }),
    getUsersUsingGet1: build.query<
      GetUsersUsingGet1ApiResponse,
      GetUsersUsingGet1ApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/report/users/${queryArg.year}/${queryArg.month}`,
      }),
    }),
    exportTemplatesUsingGetUsingGet: build.query<
      ExportTemplatesUsingGetUsingGetApiResponse,
      ExportTemplatesUsingGetUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/template`,
      }),
    }),
    importTemplatesFromFileUsingPostUsingPost: build.mutation<
      ImportTemplatesFromFileUsingPostUsingPostApiResponse,
      ImportTemplatesFromFileUsingPostUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/mgmt/tenant/${queryArg.tenantName}/template`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getNamingsUsingGet: build.query<
      GetNamingsUsingGetApiResponse,
      GetNamingsUsingGetApiArg
    >({
      query: () => ({ url: `/naming` }),
    }),
    createNamingUsingPost: build.mutation<
      CreateNamingUsingPostApiResponse,
      CreateNamingUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/naming`,
        method: "POST",
        body: queryArg.namingDto,
      }),
    }),
    updateNamingsUsingPut: build.mutation<
      UpdateNamingsUsingPutApiResponse,
      UpdateNamingsUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/naming`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    dummyNamingUsingPost: build.mutation<
      DummyNamingUsingPostApiResponse,
      DummyNamingUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/naming/dummy`,
        method: "POST",
        body: queryArg.table,
      }),
    }),
    executeNamingUsingPost: build.mutation<
      ExecuteNamingUsingPostApiResponse,
      ExecuteNamingUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/naming/execute/${queryArg.namingType}/${queryArg.structureId}`,
        method: "POST",
        params: {
          sequence_column: queryArg.sequenceColumn,
          master_node_name: queryArg.masterNodeName,
          master_node_code: queryArg.masterNodeCode,
        },
      }),
    }),
    executeNamingOverWorkingDataUsingPost: build.mutation<
      ExecuteNamingOverWorkingDataUsingPostApiResponse,
      ExecuteNamingOverWorkingDataUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/naming/execute/${queryArg.namingType}/${queryArg.structureId}/${queryArg.sqlType}`,
        method: "POST",
        body: queryArg.structureWorkingDataDto,
        params: {
          sequence_column: queryArg.sequenceColumn,
          master_node_name: queryArg.masterNodeName,
          master_node_code: queryArg.masterNodeCode,
        },
      }),
    }),
    deleteNamingUsingDelete: build.mutation<
      DeleteNamingUsingDeleteApiResponse,
      DeleteNamingUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/naming/${queryArg.namingType}`,
        method: "DELETE",
      }),
    }),
    getNamingUsingGet: build.query<
      GetNamingUsingGetApiResponse,
      GetNamingUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/naming/${queryArg.namingType}` }),
    }),
    getAllObjectSettingsUsingGet: build.query<
      GetAllObjectSettingsUsingGetApiResponse,
      GetAllObjectSettingsUsingGetApiArg
    >({
      query: () => ({ url: `/objectsettings` }),
    }),
    createObjectSettingsUsingPost: build.mutation<
      CreateObjectSettingsUsingPostApiResponse,
      CreateObjectSettingsUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings`,
        method: "POST",
        body: queryArg.objectSettingsCreateDto,
      }),
    }),
    getObjectSettingsByTypeUsingGet: build.query<
      GetObjectSettingsByTypeUsingGetApiResponse,
      GetObjectSettingsByTypeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/combo`,
        params: {
          structureType: queryArg.structureType,
        },
      }),
    }),
    getAllObjectSettingsForTargetStructureUsingGet: build.query<
      GetAllObjectSettingsForTargetStructureUsingGetApiResponse,
      GetAllObjectSettingsForTargetStructureUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/structure/${queryArg.structureId}`,
      }),
    }),
    getUsedObjectSettingsUsingGet: build.query<
      GetUsedObjectSettingsUsingGetApiResponse,
      GetUsedObjectSettingsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/used`,
        params: {
          structureId: queryArg.structureId,
        },
      }),
    }),
    deleteObjectSettingsUsingDelete: build.mutation<
      DeleteObjectSettingsUsingDeleteApiResponse,
      DeleteObjectSettingsUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/${queryArg.objectSettingsId}`,
        method: "DELETE",
      }),
    }),
    getAllObjectSettingsForTargetStructureDepUsingGet: build.query<
      GetAllObjectSettingsForTargetStructureDepUsingGetApiResponse,
      GetAllObjectSettingsForTargetStructureDepUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/${queryArg.objectSettingsId}`,
      }),
    }),
    updateObjectSettingsUsingPut: build.mutation<
      UpdateObjectSettingsUsingPutApiResponse,
      UpdateObjectSettingsUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/objectsettings/${queryArg.objectSettingsId}`,
        method: "PUT",
        body: queryArg.objectSettingsUpdateDto,
      }),
    }),
    getPermissionsUsingGet: build.query<
      GetPermissionsUsingGetApiResponse,
      GetPermissionsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/permissions`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    getAllRelationsByRelationTypeUsingGet: build.query<
      GetAllRelationsByRelationTypeUsingGetApiResponse,
      GetAllRelationsByRelationTypeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/relation`,
        params: {
          relationType: queryArg.relationType,
        },
      }),
    }),
    getStereotypeCategoriesUsingGet: build.query<
      GetStereotypeCategoriesUsingGetApiResponse,
      GetStereotypeCategoriesUsingGetApiArg
    >({
      query: () => ({ url: `/stereotype-categories` }),
    }),
    getStereotypeTypesUsingGet: build.query<
      GetStereotypeTypesUsingGetApiResponse,
      GetStereotypeTypesUsingGetApiArg
    >({
      query: () => ({ url: `/stereotype-types` }),
    }),
    getStereotypeTypesForObjectSettingsUsingGet: build.query<
      GetStereotypeTypesForObjectSettingsUsingGetApiResponse,
      GetStereotypeTypesForObjectSettingsUsingGetApiArg
    >({
      query: () => ({ url: `/stereotype-types/objectsettings` }),
    }),
    getStereotypesUsingGet: build.query<
      GetStereotypesUsingGetApiResponse,
      GetStereotypesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes`,
        params: {
          type: queryArg["type"],
          internal: queryArg.internal,
        },
      }),
    }),
    createStereotypeUsingPost: build.mutation<
      CreateStereotypeUsingPostApiResponse,
      CreateStereotypeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes`,
        method: "POST",
        body: queryArg.stereotypeCreateDto,
      }),
    }),
    getStereotypesForTemplatesUsingGet: build.query<
      GetStereotypesForTemplatesUsingGetApiResponse,
      GetStereotypesForTemplatesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes/templates`,
        params: {
          type: queryArg["type"],
        },
      }),
    }),
    getStereotypesForTableTemplatesUsingGet: build.query<
      GetStereotypesForTableTemplatesUsingGetApiResponse,
      GetStereotypesForTableTemplatesUsingGetApiArg
    >({
      query: () => ({ url: `/stereotypes/templates/tables` }),
    }),
    deleteStereotypeUsingDelete: build.mutation<
      DeleteStereotypeUsingDeleteApiResponse,
      DeleteStereotypeUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes/${queryArg.stereotypeId}`,
        method: "DELETE",
      }),
    }),
    updateStereotypeUsingPut: build.mutation<
      UpdateStereotypeUsingPutApiResponse,
      UpdateStereotypeUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes/${queryArg.stereotypeId}`,
        method: "PUT",
        body: queryArg.stereotypeUpdateDto,
      }),
    }),
    getSubStereotypesUsingGet: build.query<
      GetSubStereotypesUsingGetApiResponse,
      GetSubStereotypesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/stereotypes/${queryArg.stereotypeId}/sub-stereotypes`,
      }),
    }),
    getRootNodesUsingGet: build.query<
      GetRootNodesUsingGetApiResponse,
      GetRootNodesUsingGetApiArg
    >({
      query: () => ({ url: `/structure` }),
    }),
    createNodeUsingPost: build.mutation<
      CreateNodeUsingPostApiResponse,
      CreateNodeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure`,
        method: "POST",
        body: queryArg.newStructureDto,
      }),
    }),
    getAllStructureTypeDtoUsingGet: build.query<
      GetAllStructureTypeDtoUsingGetApiResponse,
      GetAllStructureTypeDtoUsingGetApiArg
    >({
      query: () => ({ url: `/structure-types` }),
    }),
    searchFullTextUsingGet: build.query<
      SearchFullTextUsingGetApiResponse,
      SearchFullTextUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/fulltext`,
        params: {
          searchText: queryArg.searchText,
        },
      }),
    }),
    searchFullTextJsonUsingGet: build.query<
      SearchFullTextJsonUsingGetApiResponse,
      SearchFullTextJsonUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/fulltextJson`,
        params: {
          searchText: queryArg.searchText,
        },
      }),
    }),
    importStructureFileUsingPost: build.mutation<
      ImportStructureFileUsingPostApiResponse,
      ImportStructureFileUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/import`,
        method: "POST",
        body: queryArg.structureExportDto,
      }),
    }),
    importStructureFileIntoNodeUsingPost: build.mutation<
      ImportStructureFileIntoNodeUsingPostApiResponse,
      ImportStructureFileIntoNodeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/import/${queryArg.structureId}`,
        method: "POST",
        body: queryArg.structureExportDto,
      }),
    }),
    importStructureCsvIntoNodeUsingPost: build.mutation<
      ImportStructureCsvIntoNodeUsingPostApiResponse,
      ImportStructureCsvIntoNodeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/importCsv/${queryArg.structureId}`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          importAllColumns: queryArg.importAllColumns,
          nameNormalisation: queryArg.nameNormalisation,
        },
      }),
    }),
    importStructureCsvIntoNodeCheckUsingPost: build.mutation<
      ImportStructureCsvIntoNodeCheckUsingPostApiResponse,
      ImportStructureCsvIntoNodeCheckUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/importCsv/${queryArg.structureId}/check`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
        },
      }),
    }),
    generateMassExportFileUsingPost: build.mutation<
      GenerateMassExportFileUsingPostApiResponse,
      GenerateMassExportFileUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/mass-export`,
        method: "POST",
        body: queryArg.massExportConfigDto,
        params: {
          ignoreErrors: queryArg.ignoreErrors,
        },
      }),
    }),
    searchNodesUsingGet: build.query<
      SearchNodesUsingGetApiResponse,
      SearchNodesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/search`,
        params: {
          searchText: queryArg.searchText,
        },
      }),
    }),
    searchStructureUsingGet: build.query<
      SearchStructureUsingGetApiResponse,
      SearchStructureUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/search-by-name-or-code`,
        params: {
          searchText: queryArg.searchText,
          nodeType: queryArg.nodeType,
        },
      }),
    }),
    getSystemEnvironmentsUsingGet: build.query<
      GetSystemEnvironmentsUsingGetApiResponse,
      GetSystemEnvironmentsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/environment`,
      }),
    }),
    resetVersionUsingPost: build.mutation<
      ResetVersionUsingPostApiResponse,
      ResetVersionUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/environment/${queryArg.envId}/reset`,
        method: "POST",
      }),
    }),
    takeOverVersionUsingPost: build.mutation<
      TakeOverVersionUsingPostApiResponse,
      TakeOverVersionUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/environment/${queryArg.envId}/takeover/${queryArg.fromId}`,
        method: "POST",
      }),
    }),
    getSystemReleasesUsingGet: build.query<
      GetSystemReleasesUsingGetApiResponse,
      GetSystemReleasesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release`,
        params: {
          onlyOpen: queryArg.onlyOpen,
        },
      }),
    }),
    createSystemReleaseUsingPost: build.mutation<
      CreateSystemReleaseUsingPostApiResponse,
      CreateSystemReleaseUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release`,
        method: "POST",
        body: queryArg.releaseDto,
      }),
    }),
    deleteSystemReleaseUsingDelete: build.mutation<
      DeleteSystemReleaseUsingDeleteApiResponse,
      DeleteSystemReleaseUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}`,
        method: "DELETE",
      }),
    }),
    getSystemReleaseUsingGet: build.query<
      GetSystemReleaseUsingGetApiResponse,
      GetSystemReleaseUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}`,
      }),
    }),
    updateSystemReleaseUsingPut: build.mutation<
      UpdateSystemReleaseUsingPutApiResponse,
      UpdateSystemReleaseUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}`,
        method: "PUT",
        body: queryArg.releaseDto,
      }),
    }),
    getReleaseEnvironmentsUsingGet: build.query<
      GetReleaseEnvironmentsUsingGetApiResponse,
      GetReleaseEnvironmentsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment`,
      }),
    }),
    createReleaseEnvironmentUsingPost: build.mutation<
      CreateReleaseEnvironmentUsingPostApiResponse,
      CreateReleaseEnvironmentUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment`,
        method: "POST",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    deleteReleaseEnvironmentUsingDelete: build.mutation<
      DeleteReleaseEnvironmentUsingDeleteApiResponse,
      DeleteReleaseEnvironmentUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}`,
        method: "DELETE",
      }),
    }),
    updateReleaseEnvironmentUsingPut: build.mutation<
      UpdateReleaseEnvironmentUsingPutApiResponse,
      UpdateReleaseEnvironmentUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}`,
        method: "PUT",
        body: queryArg.releaseEnvironmentDto,
      }),
    }),
    pushReleaseToGitUsingPost: build.mutation<
      PushReleaseToGitUsingPostApiResponse,
      PushReleaseToGitUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}/git`,
        method: "POST",
        body: queryArg.massExportConfigDto,
      }),
    }),
    createReleasePreviewUsingPost: build.mutation<
      CreateReleasePreviewUsingPostApiResponse,
      CreateReleasePreviewUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}/preview`,
        method: "POST",
        body: queryArg.massExportConfigDto,
      }),
    }),
    createReleaseScriptsUsingPost: build.mutation<
      CreateReleaseScriptsUsingPostApiResponse,
      CreateReleaseScriptsUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}/scripts`,
        method: "POST",
        body: queryArg.massExportConfigDto,
      }),
    }),
    createDeploymentsUsingPost: build.mutation<
      CreateDeploymentsUsingPostApiResponse,
      CreateDeploymentsUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/environment/${queryArg.envId}/scripts/deploy`,
        method: "POST",
        body: queryArg.massExportConfigDto,
      }),
    }),
    changeReleaseStatusUsingPatch: build.mutation<
      ChangeReleaseStatusUsingPatchApiResponse,
      ChangeReleaseStatusUsingPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/status/${queryArg.newStatus}`,
        method: "PATCH",
      }),
    }),
    getReleaseStructuresUsingGet: build.query<
      GetReleaseStructuresUsingGetApiResponse,
      GetReleaseStructuresUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/structure`,
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    addStructureToReleaseUsingPost: build.mutation<
      AddStructureToReleaseUsingPostApiResponse,
      AddStructureToReleaseUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/structure`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteReleaseStructureUsingDelete: build.mutation<
      DeleteReleaseStructureUsingDeleteApiResponse,
      DeleteReleaseStructureUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/release/${queryArg.releaseId}/structure/${queryArg.structureId}`,
        method: "DELETE",
      }),
    }),
    getAllTablesForSystemNodeUsingGet: build.query<
      GetAllTablesForSystemNodeUsingGetApiResponse,
      GetAllTablesForSystemNodeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemId}/tables`,
      }),
    }),
    getMappingsOfSystemNodesUsingGet: build.query<
      GetMappingsOfSystemNodesUsingGetApiResponse,
      GetMappingsOfSystemNodesUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemStructureId}/mapping`,
      }),
    }),
    getWorkflowsOfSystemNodeUsingGet: build.query<
      GetWorkflowsOfSystemNodeUsingGetApiResponse,
      GetWorkflowsOfSystemNodeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/system/${queryArg.systemStructureId}/workflow`,
      }),
    }),
    deleteNodeUsingDelete: build.mutation<
      DeleteNodeUsingDeleteApiResponse,
      DeleteNodeUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}`,
        method: "DELETE",
      }),
    }),
    getNodeDetailUsingGet: build.query<
      GetNodeDetailUsingGetApiResponse,
      GetNodeDetailUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/structure/${queryArg.structureId}` }),
    }),
    getApiNodeColumnFromAllStructuresUsingGet: build.query<
      GetApiNodeColumnFromAllStructuresUsingGetApiResponse,
      GetApiNodeColumnFromAllStructuresUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/all-columns`,
      }),
    }),
    getNodesOfSpecificParentUsingGet: build.query<
      GetNodesOfSpecificParentUsingGetApiResponse,
      GetNodesOfSpecificParentUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/children`,
        params: {
          recursive: queryArg.recursive,
        },
      }),
    }),
    createChildNodeUsingPost: build.mutation<
      CreateChildNodeUsingPostApiResponse,
      CreateChildNodeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/children`,
        method: "POST",
        body: queryArg.newStructureDto,
      }),
    }),
    importColumnsFromCsvUsingPost: build.mutation<
      ImportColumnsFromCsvUsingPostApiResponse,
      ImportColumnsFromCsvUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/columns`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          importAllColumns: queryArg.importAllColumns,
          nameNormalisation: queryArg.nameNormalisation,
        },
      }),
    }),
    importColumnsFromCsvCheckUsingPost: build.mutation<
      ImportColumnsFromCsvCheckUsingPostApiResponse,
      ImportColumnsFromCsvCheckUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/columns/check`,
        method: "POST",
        body: queryArg.body,
        params: {
          caseSensitive: queryArg.caseSensitive,
          createNewDomains: queryArg.createNewDomains,
          generateCodes: queryArg.generateCodes,
          nameNormalisation: queryArg.nameNormalisation,
        },
      }),
    }),
    deleteDataNodeUsingDelete: build.mutation<
      DeleteDataNodeUsingDeleteApiResponse,
      DeleteDataNodeUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/data`,
        method: "DELETE",
      }),
    }),
    editDataNodeUsingGet: build.query<
      EditDataNodeUsingGetApiResponse,
      EditDataNodeUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/structure/${queryArg.structureId}/data` }),
    }),
    updateDataNodeUsingPut: build.mutation<
      UpdateDataNodeUsingPutApiResponse,
      UpdateDataNodeUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/data`,
        method: "PUT",
        body: queryArg.structureWorkingDataDto,
      }),
    }),
    getDiagramUsingGet: build.query<
      GetDiagramUsingGetApiResponse,
      GetDiagramUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/diagram`,
      }),
    }),
    getDeepDiagramUsingGet: build.query<
      GetDeepDiagramUsingGetApiResponse,
      GetDeepDiagramUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/diagram/deep`,
      }),
    }),
    createFromSystemStructureUsingGet: build.query<
      CreateFromSystemStructureUsingGetApiResponse,
      CreateFromSystemStructureUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/diagram/fromSystem`,
      }),
    }),
    getDiagramFromRelationUsingGet: build.query<
      GetDiagramFromRelationUsingGetApiResponse,
      GetDiagramFromRelationUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/diagram/relation`,
      }),
    }),
    duplicateNodeUsingPost: build.mutation<
      DuplicateNodeUsingPostApiResponse,
      DuplicateNodeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/duplicate`,
        method: "POST",
      }),
    }),
    duplicateNodeRecursiveUsingPost: build.mutation<
      DuplicateNodeRecursiveUsingPostApiResponse,
      DuplicateNodeRecursiveUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/duplicate-recursive`,
        method: "POST",
        params: {
          suffix: queryArg.suffix,
          useSuffixOnly4System: queryArg.useSuffixOnly4System,
        },
      }),
    }),
    generateAndPushToGitUsingGet: build.query<
      GenerateAndPushToGitUsingGetApiResponse,
      GenerateAndPushToGitUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectSettingsId}/git`,
      }),
    }),
    generateSqlPreviewEnvironmentUsingGet: build.query<
      GenerateSqlPreviewEnvironmentUsingGetApiResponse,
      GenerateSqlPreviewEnvironmentUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectSettingsId}/preview`,
      }),
    }),
    generateSqlUsingGet: build.query<
      GenerateSqlUsingGetApiResponse,
      GenerateSqlUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectSettingsId}/sql`,
      }),
    }),
    generateSqlDownloadZipFileUsingGet: build.query<
      GenerateSqlDownloadZipFileUsingGetApiResponse,
      GenerateSqlDownloadZipFileUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/environments/${queryArg.environmentId}/objectTypes/${queryArg.objectTypeId}/sql/download-zip`,
      }),
    }),
    exportStructureUsingGet: build.query<
      ExportStructureUsingGetApiResponse,
      ExportStructureUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/export`,
      }),
    }),
    getAllNodeHistoryUsingGet: build.query<
      GetAllNodeHistoryUsingGetApiResponse,
      GetAllNodeHistoryUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/history`,
      }),
    }),
    createNodeHistoryUsingPost: build.mutation<
      CreateNodeHistoryUsingPostApiResponse,
      CreateNodeHistoryUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/history`,
        method: "POST",
        body: queryArg.newHistoryDto,
        params: {
          fixImpacts: queryArg.fixImpacts,
        },
      }),
    }),
    getNodeHistoryDetailByVersionUsingGet: build.query<
      GetNodeHistoryDetailByVersionUsingGetApiResponse,
      GetNodeHistoryDetailByVersionUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/history/version/${queryArg.version}`,
        params: {
          envId: queryArg.envId,
        },
      }),
    }),
    deleteNodeHistoryUsingDelete: build.mutation<
      DeleteNodeHistoryUsingDeleteApiResponse,
      DeleteNodeHistoryUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/history/${queryArg.historyId}`,
        method: "DELETE",
      }),
    }),
    getNodeHistoryDetailUsingGet: build.query<
      GetNodeHistoryDetailUsingGetApiResponse,
      GetNodeHistoryDetailUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/history/${queryArg.historyId}`,
      }),
    }),
    deleteNodeLockUsingDelete: build.mutation<
      DeleteNodeLockUsingDeleteApiResponse,
      DeleteNodeLockUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/lock`,
        method: "DELETE",
      }),
    }),
    createNodeLockUsingPost: build.mutation<
      CreateNodeLockUsingPostApiResponse,
      CreateNodeLockUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/lock`,
        method: "POST",
      }),
    }),
    getMappingsUsingGet: build.query<
      GetMappingsUsingGetApiResponse,
      GetMappingsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/mapping`,
      }),
    }),
    generateMassExportPushGitUsingPost: build.mutation<
      GenerateMassExportPushGitUsingPostApiResponse,
      GenerateMassExportPushGitUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/mass-export/git`,
        method: "POST",
        body: queryArg.massExportConfigDto,
      }),
    }),
    massPatchStructuresListUsingPatch: build.mutation<
      MassPatchStructuresListUsingPatchApiResponse,
      MassPatchStructuresListUsingPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/mass-update-list`,
        method: "PATCH",
        body: queryArg.massUpdateDto,
      }),
    }),
    moveNodeUsingPut: build.mutation<
      MoveNodeUsingPutApiResponse,
      MoveNodeUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/move/${queryArg.destinationStructureId}`,
        method: "PUT",
      }),
    }),
    reorderNodeUsingPut: build.mutation<
      ReorderNodeUsingPutApiResponse,
      ReorderNodeUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/order`,
        method: "PUT",
        body: queryArg.reorderStructureDto,
      }),
    }),
    patchMergeStructuresUsingPatch: build.mutation<
      PatchMergeStructuresUsingPatchApiResponse,
      PatchMergeStructuresUsingPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/patch-merge`,
        method: "PATCH",
        body: queryArg.massUpdateDto,
      }),
    }),
    getStructurePermissionsUsingGet: build.query<
      GetStructurePermissionsUsingGetApiResponse,
      GetStructurePermissionsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/permissions`,
      }),
    }),
    updateBatchEnvironmentsUsingPut: build.mutation<
      UpdateBatchEnvironmentsUsingPutApiResponse,
      UpdateBatchEnvironmentsUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/permissions`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteUserPermissionUsingDelete: build.mutation<
      DeleteUserPermissionUsingDeleteApiResponse,
      DeleteUserPermissionUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/permissions/user/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getUserPermissionUsingGet: build.query<
      GetUserPermissionUsingGetApiResponse,
      GetUserPermissionUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/permissions/user/${queryArg.userId}`,
      }),
    }),
    changeUserPermissionUsingPut: build.mutation<
      ChangeUserPermissionUsingPutApiResponse,
      ChangeUserPermissionUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/permissions/user/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.newStructureUserPermissionDto,
      }),
    }),
    prePushValidationUsingGet: build.query<
      PrePushValidationUsingGetApiResponse,
      PrePushValidationUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/prepush-validation`,
      }),
    }),
    getNodeRelationsUsingGet: build.query<
      GetNodeRelationsUsingGetApiResponse,
      GetNodeRelationsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/relation`,
      }),
    }),
    createRelationUsingPost: build.mutation<
      CreateRelationUsingPostApiResponse,
      CreateRelationUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/relation`,
        method: "POST",
        body: queryArg.relationCreateDto,
      }),
    }),
    deleteRelationUsingDelete: build.mutation<
      DeleteRelationUsingDeleteApiResponse,
      DeleteRelationUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "DELETE",
      }),
    }),
    pathRelationUsingPatch: build.mutation<
      PathRelationUsingPatchApiResponse,
      PathRelationUsingPatchApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "PATCH",
        body: queryArg.jsonPatch,
      }),
    }),
    updateRelationUsingPut: build.mutation<
      UpdateRelationUsingPutApiResponse,
      UpdateRelationUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/relation/${queryArg.relationId}`,
        method: "PUT",
        body: queryArg.relationDto,
      }),
    }),
    generateSqlPreviewUsingGet: build.query<
      GenerateSqlPreviewUsingGetApiResponse,
      GenerateSqlPreviewUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/sql`,
        params: {
          objectSettingsId: queryArg.objectSettingsId,
        },
      }),
    }),
    generateSqlPreviewDownloadZipFileUsingGet: build.query<
      GenerateSqlPreviewDownloadZipFileUsingGetApiResponse,
      GenerateSqlPreviewDownloadZipFileUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/sql/download-zip`,
        params: {
          objectTypeId: queryArg.objectTypeId,
        },
      }),
    }),
    getExistingStructuresForSourceMappingUsingGet: build.query<
      GetExistingStructuresForSourceMappingUsingGetApiResponse,
      GetExistingStructuresForSourceMappingUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/structure-object-read-only/${queryArg.sourceObjectType}`,
      }),
    }),
    getAvailableStructureForSourceObjectUsingGet: build.query<
      GetAvailableStructureForSourceObjectUsingGetApiResponse,
      GetAvailableStructureForSourceObjectUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/structure-object/${queryArg.sourceObjectType}`,
        params: {
          name: queryArg.name,
        },
      }),
    }),
    getSystemUsersUsingGet: build.query<
      GetSystemUsersUsingGetApiResponse,
      GetSystemUsersUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/system-users`,
      }),
    }),
    getSystemUserUsingGet: build.query<
      GetSystemUserUsingGetApiResponse,
      GetSystemUserUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/system-users/${queryArg.id}`,
      }),
    }),
    getUniversalColumnFromAllStructuresUsingGet: build.query<
      GetUniversalColumnFromAllStructuresUsingGetApiResponse,
      GetUniversalColumnFromAllStructuresUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/universal/all-columns`,
      }),
    }),
    getWriteColumnFromAllStructuresUsingGet: build.query<
      GetWriteColumnFromAllStructuresUsingGetApiResponse,
      GetWriteColumnFromAllStructuresUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/structure/${queryArg.structureId}/write-mapping/all-columns`,
      }),
    }),
    getAllSystemTechnologiesUsingGet: build.query<
      GetAllSystemTechnologiesUsingGetApiResponse,
      GetAllSystemTechnologiesUsingGetApiArg
    >({
      query: () => ({ url: `/system-technologies` }),
    }),
    searchTableColumnsUsingGet: build.query<
      SearchTableColumnsUsingGetApiResponse,
      SearchTableColumnsUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/system/${queryArg.systemId}/structure/table/${queryArg.tableCode}/columns`,
        params: {
          searchText: queryArg.searchText,
          actualStructureId: queryArg.actualStructureId,
        },
      }),
    }),
    searchNodesWithTypeUsingGet: build.query<
      SearchNodesWithTypeUsingGetApiResponse,
      SearchNodesWithTypeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/system/${queryArg.systemId}/structure/${queryArg.structureType}/search`,
        params: {
          searchText: queryArg.searchText,
          actualStructureId: queryArg.actualStructureId,
        },
      }),
    }),
    getAsyncTasksUsingGet: build.query<
      GetAsyncTasksUsingGetApiResponse,
      GetAsyncTasksUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/task`,
        params: {
          state: queryArg.state,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    getAsyncTasksByStructuredIdUsingGet: build.query<
      GetAsyncTasksByStructuredIdUsingGetApiResponse,
      GetAsyncTasksByStructuredIdUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/task/structure/${queryArg.structuredId}`,
        params: {
          type: queryArg["type"],
          state: queryArg.state,
          page: queryArg.page,
          pageSize: queryArg.pageSize,
        },
      }),
    }),
    createUsingPost: build.mutation<
      CreateUsingPostApiResponse,
      CreateUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/task/type/${queryArg["type"]}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    cancelTaskUsingDelete: build.mutation<
      CancelTaskUsingDeleteApiResponse,
      CancelTaskUsingDeleteApiArg
    >({
      query: (queryArg) => ({ url: `/task/${queryArg.id}`, method: "DELETE" }),
    }),
    getTaskExecutionUsingGet: build.query<
      GetTaskExecutionUsingGetApiResponse,
      GetTaskExecutionUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/task/${queryArg.id}` }),
    }),
    getTaskResultFileUsingGet: build.query<
      GetTaskResultFileUsingGetApiResponse,
      GetTaskResultFileUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/task/${queryArg.id}/bin` }),
    }),
    getTaskResultUsingGet: build.query<
      GetTaskResultUsingGetApiResponse,
      GetTaskResultUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/task/${queryArg.id}/result` }),
    }),
    getAllTechnicalColumnsUsingGet: build.query<
      GetAllTechnicalColumnsUsingGetApiResponse,
      GetAllTechnicalColumnsUsingGetApiArg
    >({
      query: () => ({ url: `/technical-columns` }),
    }),
    createTechnicalColumnUsingPost: build.mutation<
      CreateTechnicalColumnUsingPostApiResponse,
      CreateTechnicalColumnUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns`,
        method: "POST",
        body: queryArg.technicalColumnDto,
        params: {
          updateElements: queryArg.updateElements,
        },
      }),
    }),
    getTechnicalColumnStereotypeUsingGet: build.query<
      GetTechnicalColumnStereotypeUsingGetApiResponse,
      GetTechnicalColumnStereotypeUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/combo/${queryArg.stereotypeId}`,
        params: {
          technologyId: queryArg.technologyId,
        },
      }),
    }),
    deleteTechnicalColumnUsingDelete: build.mutation<
      DeleteTechnicalColumnUsingDeleteApiResponse,
      DeleteTechnicalColumnUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/${queryArg.technicalColumnId}`,
        method: "DELETE",
        params: {
          updateElements: queryArg.updateElements,
        },
      }),
    }),
    updateTechnicalColumnUsingPut: build.mutation<
      UpdateTechnicalColumnUsingPutApiResponse,
      UpdateTechnicalColumnUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/${queryArg.technicalColumnId}`,
        method: "PUT",
        body: queryArg.technicalColumnDto,
        params: {
          updateElements: queryArg.updateElements,
        },
      }),
    }),
    computeImpactTcChangeUsingPost: build.mutation<
      ComputeImpactTcChangeUsingPostApiResponse,
      ComputeImpactTcChangeUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/${queryArg.technicalColumnId}/impact`,
        method: "POST",
        body: queryArg.technicalColumnDto,
      }),
    }),
    getTablesByTechnicalColumnUsingGet: build.query<
      GetTablesByTechnicalColumnUsingGetApiResponse,
      GetTablesByTechnicalColumnUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/${queryArg.technicalColumnId}/table`,
      }),
    }),
    getTablesByTechnicalColumnCsvUsingGet: build.query<
      GetTablesByTechnicalColumnCsvUsingGetApiResponse,
      GetTablesByTechnicalColumnCsvUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/technical-columns/${queryArg.technicalColumnId}/table/csv`,
      }),
    }),
    getAllTechnologiesUsingGet: build.query<
      GetAllTechnologiesUsingGetApiResponse,
      GetAllTechnologiesUsingGetApiArg
    >({
      query: () => ({ url: `/technologies` }),
    }),
    getAllTemplatesV1UsingGet: build.query<
      GetAllTemplatesV1UsingGetApiResponse,
      GetAllTemplatesV1UsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/templates`,
        params: {
          technologyId: queryArg.technologyId,
          stereotypeId: queryArg.stereotypeId,
        },
      }),
    }),
    createTemplateV1UsingPost: build.mutation<
      CreateTemplateV1UsingPostApiResponse,
      CreateTemplateV1UsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/templates`,
        method: "POST",
        body: queryArg.templateDtoV1,
      }),
    }),
    deleteTemplateV1UsingDelete: build.mutation<
      DeleteTemplateV1UsingDeleteApiResponse,
      DeleteTemplateV1UsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/templates/${queryArg.id}`,
        method: "DELETE",
      }),
    }),
    getTemplateV1UsingGet: build.query<
      GetTemplateV1UsingGetApiResponse,
      GetTemplateV1UsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/templates/${queryArg.id}` }),
    }),
    updateTemplateV1UsingPut: build.mutation<
      UpdateTemplateV1UsingPutApiResponse,
      UpdateTemplateV1UsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/templates/${queryArg.id}`,
        method: "PUT",
        body: queryArg.templateDtoV1,
      }),
    }),
    getTemplateHistoryV1UsingGet: build.query<
      GetTemplateHistoryV1UsingGetApiResponse,
      GetTemplateHistoryV1UsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/templates/${queryArg.id}/history` }),
    }),
    getTemplateHistoryDetailV1UsingGet: build.query<
      GetTemplateHistoryDetailV1UsingGetApiResponse,
      GetTemplateHistoryDetailV1UsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/templates/${queryArg.id}/history/${queryArg.version}`,
      }),
    }),
    getUsersUsingGet: build.query<
      GetUsersUsingGetApiResponse,
      GetUsersUsingGetApiArg
    >({
      query: () => ({ url: `/users` }),
    }),
    addUserUsingPost: build.mutation<
      AddUserUsingPostApiResponse,
      AddUserUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users`,
        method: "POST",
        body: queryArg.newUserDto,
      }),
    }),
    getApiUsersUsingGet: build.query<
      GetApiUsersUsingGetApiResponse,
      GetApiUsersUsingGetApiArg
    >({
      query: () => ({ url: `/users/api` }),
    }),
    addApiUserUsingPost: build.mutation<
      AddApiUserUsingPostApiResponse,
      AddApiUserUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/api`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    deleteApiUserUsingDelete: build.mutation<
      DeleteApiUserUsingDeleteApiResponse,
      DeleteApiUserUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/users/api/${queryArg.clientId}`,
        method: "DELETE",
      }),
    }),
    apiUserUpdateUsingPost: build.mutation<
      ApiUserUpdateUsingPostApiResponse,
      ApiUserUpdateUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/api/${queryArg.clientId}`,
        method: "POST",
        body: queryArg.apiUserDto,
      }),
    }),
    apiUserResetSecretUsingPost: build.mutation<
      ApiUserResetSecretUsingPostApiResponse,
      ApiUserResetSecretUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/api/${queryArg.clientId}/reset-secret`,
        method: "POST",
      }),
    }),
    getUsersForComboUsingGet: build.query<
      GetUsersForComboUsingGetApiResponse,
      GetUsersForComboUsingGetApiArg
    >({
      query: () => ({ url: `/users/combo` }),
    }),
    getSessionContextUsingGet: build.query<
      GetSessionContextUsingGetApiResponse,
      GetSessionContextUsingGetApiArg
    >({
      query: () => ({ url: `/users/context` }),
    }),
    updateSessionContextUsingPut: build.mutation<
      UpdateSessionContextUsingPutApiResponse,
      UpdateSessionContextUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/users/context`,
        method: "PUT",
        body: queryArg.sessionContextDto,
      }),
    }),
    lockUserUsingPost: build.mutation<
      LockUserUsingPostApiResponse,
      LockUserUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/lock/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    resetUserPasswordUsingPost: build.mutation<
      ResetUserPasswordUsingPostApiResponse,
      ResetUserPasswordUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/password`,
        method: "POST",
        body: queryArg.resetPasswordDto,
      }),
    }),
    unlockUserUsingPost: build.mutation<
      UnlockUserUsingPostApiResponse,
      UnlockUserUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/users/unlock/${queryArg.userId}`,
        method: "POST",
      }),
    }),
    deleteUserUsingDelete: build.mutation<
      DeleteUserUsingDeleteApiResponse,
      DeleteUserUsingDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getUserUsingGet: build.query<
      GetUserUsingGetApiResponse,
      GetUserUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/users/${queryArg.userId}` }),
    }),
    editUserUsingPut: build.mutation<
      EditUserUsingPutApiResponse,
      EditUserUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}`,
        method: "PUT",
        body: queryArg.editUserInfoDto,
      }),
    }),
    getUserRolesUsingGet: build.query<
      GetUserRolesUsingGetApiResponse,
      GetUserRolesUsingGetApiArg
    >({
      query: (queryArg) => ({ url: `/users/${queryArg.userId}/roles` }),
    }),
    editUserRolesUsingPut: build.mutation<
      EditUserRolesUsingPutApiResponse,
      EditUserRolesUsingPutApiArg
    >({
      query: (queryArg) => ({
        url: `/users/${queryArg.userId}/roles`,
        method: "PUT",
        body: queryArg.userRolesDto,
      }),
    }),
    adjustTableNameUsingPost: build.mutation<
      AdjustTableNameUsingPostApiResponse,
      AdjustTableNameUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/util/adjust/name`,
        method: "POST",
        body: queryArg.utilsNameRequestDto,
      }),
    }),
    checkUniqueNameUsingPost: build.mutation<
      CheckUniqueNameUsingPostApiResponse,
      CheckUniqueNameUsingPostApiArg
    >({
      query: (queryArg) => ({
        url: `/util/unique/name`,
        method: "POST",
        body: queryArg.utilsNameRequestDto,
      }),
    }),
    checkStructureUsingGet: build.query<
      CheckStructureUsingGetApiResponse,
      CheckStructureUsingGetApiArg
    >({
      query: (queryArg) => ({
        url: `/validation/structure/${queryArg.structureId}`,
      }),
    }),
    getAllWorkflowTechnologiesUsingGet: build.query<
      GetAllWorkflowTechnologiesUsingGetApiResponse,
      GetAllWorkflowTechnologiesUsingGetApiArg
    >({
      query: () => ({ url: `/workflow-technologies` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as mddApiSliceGenerated };
export type GetAcronymsUsingGetApiResponse =
  /** status 200 OK */ PageableDtoAcronymDtoRead;
export type GetAcronymsUsingGetApiArg = {
  page?: number;
  size?: number;
  searchQuery?: string;
};
export type CreateAcronymUsingPostApiResponse =
  /** status 201 Created */ AcronymDtoRead;
export type CreateAcronymUsingPostApiArg = {
  acronymCreateDto: AcronymCreateDto;
};
export type DeleteAcronymUsingDeleteApiResponse = unknown;
export type DeleteAcronymUsingDeleteApiArg = {
  acronymId: number;
};
export type GetAcronymUsingGetApiResponse = /** status 200 OK */ AcronymDtoRead;
export type GetAcronymUsingGetApiArg = {
  acronymId: number;
};
export type UpdateAcronymUsingPutApiResponse =
  /** status 200 OK */ AcronymDtoRead;
export type UpdateAcronymUsingPutApiArg = {
  acronymId: number;
  acronymUpdateDto: AcronymUpdateDto;
};
export type GetAuditLogsUsingGetApiResponse =
  /** status 200 OK */ StructureAudit[];
export type GetAuditLogsUsingGetApiArg = {
  entityId: number;
  entityType: EntityType;
};
export type GetAllBusinessDomainsUsingGetApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead[];
export type GetAllBusinessDomainsUsingGetApiArg = void;
export type CreateBusinessDomainUsingPostApiResponse =
  /** status 201 Created */ BusinessDomainDtoRead;
export type CreateBusinessDomainUsingPostApiArg = {
  businessDomainDto: BusinessDomainDto;
};
export type GetAllBusinessDomainsForComboUsingGetApiResponse =
  /** status 200 OK */ BusinessDomainComboDto[];
export type GetAllBusinessDomainsForComboUsingGetApiArg = void;
export type DeleteBusinessDomainUsingDeleteApiResponse = unknown;
export type DeleteBusinessDomainUsingDeleteApiArg = {
  /** Business Domain id */
  businessDomainId: number;
};
export type GetBusinessDomainUsingGetApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type GetBusinessDomainUsingGetApiArg = {
  /** Business Domain id */
  businessDomainId: number;
};
export type UpdateBusinessDomainUsingPutApiResponse =
  /** status 200 OK */ BusinessDomainDtoRead;
export type UpdateBusinessDomainUsingPutApiArg = {
  /** BusinessDomain id */
  businessDomainId: number;
  businessDomainDto: BusinessDomainDto;
};
export type GetCompanyUsingGetApiResponse = /** status 200 OK */ Company;
export type GetCompanyUsingGetApiArg = void;
export type GetAllCustomAttributeStructureTypeDtoUsingGetApiResponse =
  /** status 200 OK */ StructureTypeDto[];
export type GetAllCustomAttributeStructureTypeDtoUsingGetApiArg = void;
export type GetAllCustomAttributesUsingGetApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead[];
export type GetAllCustomAttributesUsingGetApiArg = void;
export type CreateCustomAttributeUsingPostApiResponse =
  /** status 201 Created */ CustomAttributeDtoRead;
export type CreateCustomAttributeUsingPostApiArg = {
  customAttributeCreateDto: CustomAttributeCreateDto;
};
export type GetAllCustomAttributesForComboUsingGetApiResponse =
  /** status 200 OK */ CustomAttributeComboDto[];
export type GetAllCustomAttributesForComboUsingGetApiArg = {
  structureType: CustomAttributeStructureTypeEnum;
};
export type DeleteCustomAttributeUsingDeleteApiResponse = unknown;
export type DeleteCustomAttributeUsingDeleteApiArg = {
  /** Custom Attribute id */
  customAttributeId: number;
};
export type GetCustomAttributeUsingGetApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type GetCustomAttributeUsingGetApiArg = {
  /** Custom Attributes id */
  customAttributeId: number;
};
export type UpdateCustomAttributeUsingPutApiResponse =
  /** status 200 OK */ CustomAttributeDtoRead;
export type UpdateCustomAttributeUsingPutApiArg = {
  /** Custom Attribute id */
  customAttributeId: number;
  customAttributeUpdateDto: CustomAttributeUpdateDto;
};
export type GetAllCustomLovsUsingGetApiResponse =
  /** status 200 OK */ CustomLovDtoRead[];
export type GetAllCustomLovsUsingGetApiArg = void;
export type CreateCustomLovUsingPostApiResponse =
  /** status 201 Created */ CustomLovDtoRead;
export type CreateCustomLovUsingPostApiArg = {
  customLovCreateDto: CustomLovCreateDto;
};
export type GetAllCustomLovForComboUsingGetApiResponse =
  /** status 200 OK */ CustomLovComboDto[];
export type GetAllCustomLovForComboUsingGetApiArg = void;
export type DeleteCustomLovUsingDeleteApiResponse = unknown;
export type DeleteCustomLovUsingDeleteApiArg = {
  /** Custom Lov id */
  customLovId: number;
};
export type GetCustomLovUsingGetApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type GetCustomLovUsingGetApiArg = {
  /** Custom LOV id */
  customLovId: number;
};
export type UpdateCustomLovUsingPutApiResponse =
  /** status 200 OK */ CustomLovDtoRead;
export type UpdateCustomLovUsingPutApiArg = {
  /** Custom LOV id */
  customLovId: number;
  customLovUpdateDto: CustomLovUpdateDto;
};
export type GetCustomLovForComboByIdUsingGetApiResponse =
  /** status 200 OK */ CustomLovComboDto;
export type GetCustomLovForComboByIdUsingGetApiArg = {
  /** Custom LOV id */
  customLovId: number;
};
export type GetAllNodeDeploymentsUsingGetApiResponse =
  /** status 200 OK */ DeploymentDto[];
export type GetAllNodeDeploymentsUsingGetApiArg = {
  structureId: number;
  sqlType?: SqlType;
};
export type GetAllSpDeploymentsUsingGetApiResponse =
  /** status 200 OK */ DeploymentDto;
export type GetAllSpDeploymentsUsingGetApiArg = {
  structureId: number;
  environmentId: number;
  objectTypeId: number;
};
export type CreateDeployUsingPostApiResponse =
  /** status 200 OK */ DeploymentDto;
export type CreateDeployUsingPostApiArg = {
  structureId: number;
  environmentId: number;
  objectTypeId: number;
  deploymentNewDto: DeploymentNewDto;
};
export type GetDeploymentDetailUsingGetApiResponse =
  /** status 200 OK */ DeploymentDetailDto;
export type GetDeploymentDetailUsingGetApiArg = {
  deploymentId: number;
};
export type GetAllDomainsUsingGetApiResponse = /** status 200 OK */ DomainDto[];
export type GetAllDomainsUsingGetApiArg = void;
export type CreateDomainUsingPostApiResponse =
  /** status 201 Created */ DomainDto;
export type CreateDomainUsingPostApiArg = {
  domainCreateDto: DomainCreateDto;
};
export type GetAllDomainsForComboUsingGetApiResponse =
  /** status 200 OK */ DomainComboDto[];
export type GetAllDomainsForComboUsingGetApiArg = void;
export type GetAllDomainsFilteredBySystemTechnologyUsingGetApiResponse =
  /** status 200 OK */ DomainDto[];
export type GetAllDomainsFilteredBySystemTechnologyUsingGetApiArg = {
  /** System structure ID */
  systemStructureId: number;
};
export type DeleteDomainUsingDeleteApiResponse = unknown;
export type DeleteDomainUsingDeleteApiArg = {
  /** Domain id */
  domainId: number;
};
export type GetAllDomainsFilteredBySystemTechnologyDepUsingGetApiResponse =
  /** status 200 OK */ DomainDto[];
export type GetAllDomainsFilteredBySystemTechnologyDepUsingGetApiArg = {
  /** System structure ID */
  domainId: number;
};
export type UpdateDomainUsingPutApiResponse = /** status 200 OK */ DomainDto;
export type UpdateDomainUsingPutApiArg = {
  /** Domain id */
  domainId: number;
  /** Update affected elements */
  updateElements?: boolean;
  domainUpdateDto: DomainUpdateDto;
};
export type GetColumnsByDomainUsingGetApiResponse =
  /** status 200 OK */ ImpactedColumnDto[];
export type GetColumnsByDomainUsingGetApiArg = {
  /** Domain id */
  domainId: number;
};
export type GetColumnsByDomainCsvUsingGetApiResponse =
  /** status 200 OK */ string;
export type GetColumnsByDomainCsvUsingGetApiArg = {
  /** Domain id */
  domainId: number;
};
export type ComputeImpactDomainChangeUsingPostApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactDomainChangeUsingPostApiArg = {
  /** Domain id */
  domainId: number;
  domainUpdateDto: DomainUpdateDto;
};
export type GetEnvironmentsUsingGetApiResponse =
  /** status 200 OK */ EnvironmentDtoRead[];
export type GetEnvironmentsUsingGetApiArg = {
  structureId: number;
};
export type GetEnvironmentsWithLastDeploymentUsingGetApiResponse =
  /** status 200 OK */ EnvironmentDeploymentDtoRead[];
export type GetEnvironmentsWithLastDeploymentUsingGetApiArg = {
  structureId: number;
};
export type GetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetApiResponse =
  /** status 200 OK */ EnvironmentDeploymentDtoRead[];
export type GetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetApiArg = {
  structureId: number;
};
export type GetEnvironmentByIdUsingGetApiResponse =
  /** status 200 OK */ EnvironmentDtoRead;
export type GetEnvironmentByIdUsingGetApiArg = {
  environmentId: number;
};
export type CheckFileUsingPostApiResponse = /** status 200 OK */ CheckResult;
export type CheckFileUsingPostApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  body: {
    file: Blob;
  };
};
export type CheckJsonUsingPostApiResponse = /** status 200 OK */ CheckResult;
export type CheckJsonUsingPostApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type ImportFileUsingPostApiResponse = /** status 200 OK */ Structure[];
export type ImportFileUsingPostApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  body: {
    file: Blob;
  };
};
export type ImportStructuresUsingPostApiResponse =
  /** status 200 OK */ Structure[];
export type ImportStructuresUsingPostApiArg = {
  parentId?: number;
  /** Existing elements update mode */
  existingElementsMode?: ExistingElementsEnum;
  /** Create missing domains */
  createDomains?: boolean;
  /** Create domains including duplicities */
  ignoreDomainDuplicities?: boolean;
  /** Create missing stereotypes */
  createStereotypes?: boolean;
  /** Ignore missing business properties like responsible person, analyst, business domain, custom attributes */
  ignoreMissingBo?: boolean;
  /** Ignore missing object types */
  ignoreMissingObjectTypes?: boolean;
  /** Ignore technical columns collision */
  ignoreTechnicalColumnCollision?: boolean;
  /** Ignore inconsistent domains */
  ignoreInconsistentDomain?: boolean;
  fkMissingTable?: FkMissingTable;
  fkMoreTables?: FkMoreTables;
  /** Aggregate messages by type */
  detailReport?: string;
  structureExportDto: StructureExportDto;
};
export type GetInitInfoUsingGetApiResponse = /** status 200 OK */ InitInfoDto;
export type GetInitInfoUsingGetApiArg = void;
export type SyncRolesUsingPostApiResponse = /** status 200 OK */ {
  [key: string]: string[];
};
export type SyncRolesUsingPostApiArg = void;
export type SyncSupportUsersUsingPostApiResponse = /** status 200 OK */ {
  [key: string]: string[];
};
export type SyncSupportUsersUsingPostApiArg = void;
export type MgmtCreateTenantUsingPostApiResponse = unknown;
export type MgmtCreateTenantUsingPostApiArg = {
  tenantName: string;
};
export type GetAllAcronymsUsingGetApiResponse = unknown;
export type GetAllAcronymsUsingGetApiArg = {
  tenantName: string;
};
export type ImportAcronymsFromFileUsingPostUsingPostApiResponse = unknown;
export type ImportAcronymsFromFileUsingPostUsingPostApiArg = {
  tenantName: string;
  body: AcronymCreateDto[];
};
export type GetCodeListUsingGetApiResponse = /** status 200 OK */ CodeListRead;
export type GetCodeListUsingGetApiArg = {
  tenantName: string;
  codeListType?: CodeListType[];
};
export type ImportCodeListUsingPostUsingPostApiResponse = unknown;
export type ImportCodeListUsingPostUsingPostApiArg = {
  tenantName: string;
  codeListType?: CodeListType[];
  codeList: CodeList;
};
export type GetUsersUsingGet1ApiResponse =
  /** status 200 OK */ UserMonthlyReportDto[];
export type GetUsersUsingGet1ApiArg = {
  tenantName: string;
  month: number;
  year: number;
};
export type ExportTemplatesUsingGetUsingGetApiResponse =
  /** status 200 OK */ TemplateDtoRead[];
export type ExportTemplatesUsingGetUsingGetApiArg = {
  tenantName: string;
};
export type ImportTemplatesFromFileUsingPostUsingPostApiResponse =
  /** status 200 OK */ AdjustResultDto[];
export type ImportTemplatesFromFileUsingPostUsingPostApiArg = {
  tenantName: string;
  body: TemplateDto[];
};
export type GetNamingsUsingGetApiResponse = /** status 200 OK */ NamingDto[];
export type GetNamingsUsingGetApiArg = void;
export type CreateNamingUsingPostApiResponse =
  /** status 201 Created */ NamingDto;
export type CreateNamingUsingPostApiArg = {
  namingDto: NamingDto;
};
export type UpdateNamingsUsingPutApiResponse = /** status 200 OK */ NamingDto[];
export type UpdateNamingsUsingPutApiArg = {
  body: NamingDto[];
};
export type DummyNamingUsingPostApiResponse =
  /** status 200 OK */ AdjustResultDto;
export type DummyNamingUsingPostApiArg = {
  table: Table;
};
export type ExecuteNamingUsingPostApiResponse =
  /** status 200 OK */ AdjustResultDto;
export type ExecuteNamingUsingPostApiArg = {
  /** namingType */
  namingType: NamingTypeEnum;
  /** StructureId */
  structureId: number;
  sequenceColumn?: string;
  masterNodeName?: string;
  masterNodeCode?: string;
};
export type ExecuteNamingOverWorkingDataUsingPostApiResponse =
  /** status 200 OK */ AdjustResultDto;
export type ExecuteNamingOverWorkingDataUsingPostApiArg = {
  /** namingType */
  namingType: NamingTypeEnum;
  /** StructureId */
  structureId: number;
  /** sqlType */
  sqlType: SqlType;
  sequenceColumn?: string;
  masterNodeName?: string;
  masterNodeCode?: string;
  structureWorkingDataDto: StructureWorkingDataDto;
};
export type DeleteNamingUsingDeleteApiResponse = unknown;
export type DeleteNamingUsingDeleteApiArg = {
  /** Naming type */
  namingType: NamingTypeEnum;
};
export type GetNamingUsingGetApiResponse = /** status 200 OK */ NamingDto;
export type GetNamingUsingGetApiArg = {
  /** Naming type */
  namingType: NamingTypeEnum;
};
export type GetAllObjectSettingsUsingGetApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetAllObjectSettingsUsingGetApiArg = void;
export type CreateObjectSettingsUsingPostApiResponse =
  /** status 201 Created */ ObjectSettingsDtoRead;
export type CreateObjectSettingsUsingPostApiArg = {
  objectSettingsCreateDto: ObjectSettingsCreateDto;
};
export type GetObjectSettingsByTypeUsingGetApiResponse =
  /** status 200 OK */ ObjectSettingsComboDto[];
export type GetObjectSettingsByTypeUsingGetApiArg = {
  structureType?: StructureType;
};
export type GetAllObjectSettingsForTargetStructureUsingGetApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetAllObjectSettingsForTargetStructureUsingGetApiArg = {
  structureId: number;
};
export type GetUsedObjectSettingsUsingGetApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetUsedObjectSettingsUsingGetApiArg = {
  structureId: number[];
};
export type DeleteObjectSettingsUsingDeleteApiResponse = unknown;
export type DeleteObjectSettingsUsingDeleteApiArg = {
  /** ObjectSettings id */
  objectSettingsId: number;
};
export type GetAllObjectSettingsForTargetStructureDepUsingGetApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead[];
export type GetAllObjectSettingsForTargetStructureDepUsingGetApiArg = {
  /** Structure ID */
  objectSettingsId: number;
};
export type UpdateObjectSettingsUsingPutApiResponse =
  /** status 200 OK */ ObjectSettingsDtoRead;
export type UpdateObjectSettingsUsingPutApiArg = {
  /** ObjectSettings id */
  objectSettingsId: number;
  objectSettingsUpdateDto: ObjectSettingsUpdateDto;
};
export type GetPermissionsUsingGetApiResponse =
  /** status 200 OK */ Permission[];
export type GetPermissionsUsingGetApiArg = {
  type?: PermissionType;
};
export type GetAllRelationsByRelationTypeUsingGetApiResponse =
  /** status 200 OK */ RelationDto[];
export type GetAllRelationsByRelationTypeUsingGetApiArg = {
  relationType?: RelationType;
};
export type GetStereotypeCategoriesUsingGetApiResponse =
  /** status 200 OK */ StereotypeCategoryDto[];
export type GetStereotypeCategoriesUsingGetApiArg = void;
export type GetStereotypeTypesUsingGetApiResponse =
  /** status 200 OK */ StereotypeTypeDto[];
export type GetStereotypeTypesUsingGetApiArg = void;
export type GetStereotypeTypesForObjectSettingsUsingGetApiResponse =
  /** status 200 OK */ StereotypeTypeDto[];
export type GetStereotypeTypesForObjectSettingsUsingGetApiArg = void;
export type GetStereotypesUsingGetApiResponse =
  /** status 200 OK */ StereotypeDto[];
export type GetStereotypesUsingGetApiArg = {
  type?: StereotypeType;
  internal?: boolean;
};
export type CreateStereotypeUsingPostApiResponse =
  /** status 201 Created */ StereotypeDto;
export type CreateStereotypeUsingPostApiArg = {
  stereotypeCreateDto: StereotypeCreateDto;
};
export type GetStereotypesForTemplatesUsingGetApiResponse =
  /** status 200 OK */ StereotypeDto[];
export type GetStereotypesForTemplatesUsingGetApiArg = {
  type?: StereotypeType;
};
export type GetStereotypesForTableTemplatesUsingGetApiResponse =
  /** status 200 OK */ StereotypeDto[];
export type GetStereotypesForTableTemplatesUsingGetApiArg = void;
export type DeleteStereotypeUsingDeleteApiResponse = unknown;
export type DeleteStereotypeUsingDeleteApiArg = {
  /** Stereotype id */
  stereotypeId: number;
};
export type UpdateStereotypeUsingPutApiResponse =
  /** status 200 OK */ StereotypeDto;
export type UpdateStereotypeUsingPutApiArg = {
  /** Stereotype id */
  stereotypeId: number;
  stereotypeUpdateDto: StereotypeUpdateDto;
};
export type GetSubStereotypesUsingGetApiResponse =
  /** status 200 OK */ StereotypeDto[];
export type GetSubStereotypesUsingGetApiArg = {
  stereotypeId: number;
};
export type GetRootNodesUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetRootNodesUsingGetApiArg = void;
export type CreateNodeUsingPostApiResponse = /** status 200 OK */ StructureDto;
export type CreateNodeUsingPostApiArg = {
  newStructureDto: NewStructureDto;
};
export type GetAllStructureTypeDtoUsingGetApiResponse =
  /** status 200 OK */ StructureTypeDto[];
export type GetAllStructureTypeDtoUsingGetApiArg = void;
export type SearchFullTextUsingGetApiResponse =
  /** status 200 OK */ FullTextSearchDto[];
export type SearchFullTextUsingGetApiArg = {
  searchText: string;
};
export type SearchFullTextJsonUsingGetApiResponse =
  /** status 200 OK */ FullTextSearchDto[];
export type SearchFullTextJsonUsingGetApiArg = {
  searchText: string;
};
export type ImportStructureFileUsingPostApiResponse = unknown;
export type ImportStructureFileUsingPostApiArg = {
  structureExportDto: StructureExportDto;
};
export type ImportStructureFileIntoNodeUsingPostApiResponse = unknown;
export type ImportStructureFileIntoNodeUsingPostApiArg = {
  structureId: number;
  structureExportDto: StructureExportDto;
};
export type ImportStructureCsvIntoNodeUsingPostApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportStructureCsvIntoNodeUsingPostApiArg = {
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  importAllColumns?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  body: CsvImportRowDto[];
};
export type ImportStructureCsvIntoNodeCheckUsingPostApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportStructureCsvIntoNodeCheckUsingPostApiArg = {
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  body: CsvImportRowDto[];
};
export type GenerateMassExportFileUsingPostApiResponse =
  /** status 200 OK */ string;
export type GenerateMassExportFileUsingPostApiArg = {
  ignoreErrors?: boolean;
  massExportConfigDto: MassExportConfigDto;
};
export type SearchNodesUsingGetApiResponse =
  /** status 200 OK */ StructureSearchedDto[];
export type SearchNodesUsingGetApiArg = {
  searchText: string;
};
export type SearchStructureUsingGetApiResponse =
  /** status 200 OK */ StructureObjectDto[];
export type SearchStructureUsingGetApiArg = {
  searchText: string;
  nodeType?: NodeType;
};
export type GetSystemEnvironmentsUsingGetApiResponse =
  /** status 200 OK */ EnvironmentDtoRead[];
export type GetSystemEnvironmentsUsingGetApiArg = {
  /** Id of system */
  systemId: number;
};
export type ResetVersionUsingPostApiResponse = unknown;
export type ResetVersionUsingPostApiArg = {
  /** Id of system */
  systemId: number;
  /** Id of environment */
  envId: number;
};
export type TakeOverVersionUsingPostApiResponse = unknown;
export type TakeOverVersionUsingPostApiArg = {
  /** Id of system */
  systemId: number;
  /** Id destination environment */
  envId: number;
  /** Id source environment */
  fromId: number;
};
export type GetSystemReleasesUsingGetApiResponse =
  /** status 200 OK */ ReleaseDtoRead[];
export type GetSystemReleasesUsingGetApiArg = {
  systemId: number;
  /** Only opened releases */
  onlyOpen?: boolean;
};
export type CreateSystemReleaseUsingPostApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type CreateSystemReleaseUsingPostApiArg = {
  systemId: number;
  releaseDto: ReleaseDtoWrite;
};
export type DeleteSystemReleaseUsingDeleteApiResponse = unknown;
export type DeleteSystemReleaseUsingDeleteApiArg = {
  systemId: number;
  releaseId: number;
};
export type GetSystemReleaseUsingGetApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type GetSystemReleaseUsingGetApiArg = {
  systemId: number;
  releaseId: number;
};
export type UpdateSystemReleaseUsingPutApiResponse =
  /** status 200 OK */ ReleaseDtoRead;
export type UpdateSystemReleaseUsingPutApiArg = {
  systemId: number;
  releaseId: number;
  releaseDto: ReleaseDtoWrite;
};
export type GetReleaseEnvironmentsUsingGetApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto[];
export type GetReleaseEnvironmentsUsingGetApiArg = {
  systemId: number;
  releaseId: number;
};
export type CreateReleaseEnvironmentUsingPostApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type CreateReleaseEnvironmentUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type DeleteReleaseEnvironmentUsingDeleteApiResponse = unknown;
export type DeleteReleaseEnvironmentUsingDeleteApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
};
export type UpdateReleaseEnvironmentUsingPutApiResponse =
  /** status 200 OK */ ReleaseEnvironmentDto;
export type UpdateReleaseEnvironmentUsingPutApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
  releaseEnvironmentDto: ReleaseEnvironmentDto;
};
export type PushReleaseToGitUsingPostApiResponse = unknown;
export type PushReleaseToGitUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
  massExportConfigDto: MassExportConfigDto;
};
export type CreateReleasePreviewUsingPostApiResponse =
  /** status 200 OK */ string;
export type CreateReleasePreviewUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
  massExportConfigDto: MassExportConfigDto;
};
export type CreateReleaseScriptsUsingPostApiResponse =
  /** status 200 OK */ string;
export type CreateReleaseScriptsUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
  massExportConfigDto: MassExportConfigDto;
};
export type CreateDeploymentsUsingPostApiResponse = unknown;
export type CreateDeploymentsUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  envId: number;
  massExportConfigDto: MassExportConfigDto;
};
export type ChangeReleaseStatusUsingPatchApiResponse = unknown;
export type ChangeReleaseStatusUsingPatchApiArg = {
  systemId: number;
  releaseId: number;
  newStatus: ReleaseStatusEnum;
};
export type GetReleaseStructuresUsingGetApiResponse =
  /** status 200 OK */ PageWrapperStructureReleaseInfoDto;
export type GetReleaseStructuresUsingGetApiArg = {
  systemId: number;
  releaseId: number;
  page?: number;
  pageSize?: number;
};
export type AddStructureToReleaseUsingPostApiResponse = unknown;
export type AddStructureToReleaseUsingPostApiArg = {
  systemId: number;
  releaseId: number;
  body: number[];
};
export type DeleteReleaseStructureUsingDeleteApiResponse = unknown;
export type DeleteReleaseStructureUsingDeleteApiArg = {
  systemId: number;
  releaseId: number;
  structureId: number;
};
export type GetAllTablesForSystemNodeUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetAllTablesForSystemNodeUsingGetApiArg = {
  systemId: number;
};
export type GetMappingsOfSystemNodesUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetMappingsOfSystemNodesUsingGetApiArg = {
  systemStructureId: number;
};
export type GetWorkflowsOfSystemNodeUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetWorkflowsOfSystemNodeUsingGetApiArg = {
  systemStructureId: number;
};
export type DeleteNodeUsingDeleteApiResponse = unknown;
export type DeleteNodeUsingDeleteApiArg = {
  structureId: number;
};
export type GetNodeDetailUsingGetApiResponse =
  /** status 200 OK */ StructureDetailDto;
export type GetNodeDetailUsingGetApiArg = {
  structureId: number;
};
export type GetApiNodeColumnFromAllStructuresUsingGetApiResponse =
  /** status 200 OK */ ApiNodeColumnDto[];
export type GetApiNodeColumnFromAllStructuresUsingGetApiArg = {
  structureId: number;
};
export type GetNodesOfSpecificParentUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetNodesOfSpecificParentUsingGetApiArg = {
  structureId: number;
  recursive?: boolean;
};
export type CreateChildNodeUsingPostApiResponse =
  /** status 200 OK */ StructureDetailDto;
export type CreateChildNodeUsingPostApiArg = {
  structureId: number;
  newStructureDto: NewStructureDto;
};
export type ImportColumnsFromCsvUsingPostApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportColumnsFromCsvUsingPostApiArg = {
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  importAllColumns?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  body: ImportColumn[];
};
export type ImportColumnsFromCsvCheckUsingPostApiResponse =
  /** status 200 OK */ CsvImportReturnDto;
export type ImportColumnsFromCsvCheckUsingPostApiArg = {
  structureId: number;
  caseSensitive?: boolean;
  createNewDomains?: boolean;
  generateCodes?: boolean;
  nameNormalisation?: NameNormalisationEnum;
  body: ImportColumn[];
};
export type DeleteDataNodeUsingDeleteApiResponse = unknown;
export type DeleteDataNodeUsingDeleteApiArg = {
  structureId: number;
};
export type EditDataNodeUsingGetApiResponse =
  /** status 200 OK */ StructureDataDto;
export type EditDataNodeUsingGetApiArg = {
  structureId: number;
};
export type UpdateDataNodeUsingPutApiResponse = unknown;
export type UpdateDataNodeUsingPutApiArg = {
  structureId: number;
  structureWorkingDataDto: StructureWorkingDataDto;
};
export type GetDiagramUsingGetApiResponse =
  /** status 200 OK */ TableDiagramDto;
export type GetDiagramUsingGetApiArg = {
  structureId: number;
};
export type GetDeepDiagramUsingGetApiResponse =
  /** status 200 OK */ TableDiagramDto;
export type GetDeepDiagramUsingGetApiArg = {
  structureId: number;
};
export type CreateFromSystemStructureUsingGetApiResponse =
  /** status 200 OK */ TableDiagramDto;
export type CreateFromSystemStructureUsingGetApiArg = {
  structureId: number;
};
export type GetDiagramFromRelationUsingGetApiResponse =
  /** status 200 OK */ TableDiagramDto;
export type GetDiagramFromRelationUsingGetApiArg = {
  structureId: number;
};
export type DuplicateNodeUsingPostApiResponse =
  /** status 200 OK */ StructureDetailDto;
export type DuplicateNodeUsingPostApiArg = {
  structureId: number;
};
export type DuplicateNodeRecursiveUsingPostApiResponse =
  /** status 200 OK */ string;
export type DuplicateNodeRecursiveUsingPostApiArg = {
  structureId: number;
  suffix?: string;
  useSuffixOnly4System?: boolean;
};
export type GenerateAndPushToGitUsingGetApiResponse = unknown;
export type GenerateAndPushToGitUsingGetApiArg = {
  structureId: number;
  environmentId: number;
  objectSettingsId: number;
};
export type GenerateSqlPreviewEnvironmentUsingGetApiResponse =
  /** status 200 OK */ GeneratedSqlDtoRead;
export type GenerateSqlPreviewEnvironmentUsingGetApiArg = {
  structureId: number;
  environmentId: number;
  objectSettingsId: number;
};
export type GenerateSqlUsingGetApiResponse =
  /** status 200 OK */ GeneratedSqlDtoRead;
export type GenerateSqlUsingGetApiArg = {
  structureId: number;
  environmentId: number;
  objectSettingsId: number;
};
export type GenerateSqlDownloadZipFileUsingGetApiResponse = unknown;
export type GenerateSqlDownloadZipFileUsingGetApiArg = {
  structureId: number;
  environmentId: number;
  objectTypeId: number;
};
export type ExportStructureUsingGetApiResponse =
  /** status 200 OK */ StructureExport;
export type ExportStructureUsingGetApiArg = {
  structureId: number;
};
export type GetAllNodeHistoryUsingGetApiResponse =
  /** status 200 OK */ HistoryWithDeploymentDto[];
export type GetAllNodeHistoryUsingGetApiArg = {
  structureId: number;
};
export type CreateNodeHistoryUsingPostApiResponse =
  /** status 200 OK */ HistoryDto;
export type CreateNodeHistoryUsingPostApiArg = {
  structureId: number;
  fixImpacts?: boolean;
  newHistoryDto: NewHistoryDto;
};
export type GetNodeHistoryDetailByVersionUsingGetApiResponse =
  /** status 200 OK */ HistoryDetailDto;
export type GetNodeHistoryDetailByVersionUsingGetApiArg = {
  structureId: number;
  version: number;
  envId?: number;
};
export type DeleteNodeHistoryUsingDeleteApiResponse = unknown;
export type DeleteNodeHistoryUsingDeleteApiArg = {
  structureId: number;
  historyId: number;
};
export type GetNodeHistoryDetailUsingGetApiResponse =
  /** status 200 OK */ HistoryDetailDto;
export type GetNodeHistoryDetailUsingGetApiArg = {
  structureId: number;
  historyId: number;
};
export type DeleteNodeLockUsingDeleteApiResponse = unknown;
export type DeleteNodeLockUsingDeleteApiArg = {
  structureId: number;
};
export type CreateNodeLockUsingPostApiResponse = unknown;
export type CreateNodeLockUsingPostApiArg = {
  structureId: number;
};
export type GetMappingsUsingGetApiResponse =
  /** status 200 OK */ StructureDto[];
export type GetMappingsUsingGetApiArg = {
  structureId: number;
};
export type GenerateMassExportPushGitUsingPostApiResponse = unknown;
export type GenerateMassExportPushGitUsingPostApiArg = {
  structureId: number;
  massExportConfigDto: MassExportConfigDto;
};
export type MassPatchStructuresListUsingPatchApiResponse =
  /** status 200 OK */ string;
export type MassPatchStructuresListUsingPatchApiArg = {
  structureId: number;
  massUpdateDto: MassUpdateDto;
};
export type MoveNodeUsingPutApiResponse = unknown;
export type MoveNodeUsingPutApiArg = {
  structureId: number;
  destinationStructureId: number;
};
export type ReorderNodeUsingPutApiResponse = unknown;
export type ReorderNodeUsingPutApiArg = {
  structureId: number;
  reorderStructureDto: ReorderStructureDto;
};
export type PatchMergeStructuresUsingPatchApiResponse = /** status 200 OK */ {
  [key: string]: any;
};
export type PatchMergeStructuresUsingPatchApiArg = {
  structureId: number;
  massUpdateDto: MassUpdateDto;
};
export type GetStructurePermissionsUsingGetApiResponse =
  /** status 200 OK */ StructureUserPermissionDto[];
export type GetStructurePermissionsUsingGetApiArg = {
  structureId: number;
};
export type UpdateBatchEnvironmentsUsingPutApiResponse =
  /** status 200 OK */ StructureUserPermissionDto[];
export type UpdateBatchEnvironmentsUsingPutApiArg = {
  structureId: number;
  body: NewStructureUserPermissionBatchDto[];
};
export type DeleteUserPermissionUsingDeleteApiResponse = unknown;
export type DeleteUserPermissionUsingDeleteApiArg = {
  structureId: number;
  userId: number;
};
export type GetUserPermissionUsingGetApiResponse =
  /** status 200 OK */ StructureUserPermissionDto;
export type GetUserPermissionUsingGetApiArg = {
  structureId: number;
  userId: number;
};
export type ChangeUserPermissionUsingPutApiResponse = unknown;
export type ChangeUserPermissionUsingPutApiArg = {
  structureId: number;
  userId: number;
  newStructureUserPermissionDto: NewStructureUserPermissionDto;
};
export type PrePushValidationUsingGetApiResponse =
  /** status 200 OK */ PrePushValidationDto[];
export type PrePushValidationUsingGetApiArg = {
  structureId: number;
};
export type GetNodeRelationsUsingGetApiResponse =
  /** status 200 OK */ RelationDto[];
export type GetNodeRelationsUsingGetApiArg = {
  structureId: number;
};
export type CreateRelationUsingPostApiResponse =
  /** status 200 OK */ RelationDto;
export type CreateRelationUsingPostApiArg = {
  structureId: number;
  relationCreateDto: RelationCreateDto;
};
export type DeleteRelationUsingDeleteApiResponse = unknown;
export type DeleteRelationUsingDeleteApiArg = {
  structureId: number;
  relationId: number;
};
export type PathRelationUsingPatchApiResponse =
  /** status 200 OK */ RelationDto;
export type PathRelationUsingPatchApiArg = {
  structureId: number;
  relationId: number;
  jsonPatch: JsonPatch;
};
export type UpdateRelationUsingPutApiResponse =
  /** status 200 OK */ RelationDto;
export type UpdateRelationUsingPutApiArg = {
  structureId: number;
  relationId: number;
  relationDto: RelationDto;
};
export type GenerateSqlPreviewUsingGetApiResponse =
  /** status 200 OK */ GeneratedSqlDtoRead;
export type GenerateSqlPreviewUsingGetApiArg = {
  structureId: number;
  objectSettingsId?: number;
};
export type GenerateSqlPreviewDownloadZipFileUsingGetApiResponse = unknown;
export type GenerateSqlPreviewDownloadZipFileUsingGetApiArg = {
  structureId: number;
  objectTypeId?: number;
};
export type GetExistingStructuresForSourceMappingUsingGetApiResponse =
  /** status 200 OK */ StructureObjectDto[];
export type GetExistingStructuresForSourceMappingUsingGetApiArg = {
  structureId: number;
  sourceObjectType: StructureType;
};
export type GetAvailableStructureForSourceObjectUsingGetApiResponse =
  /** status 200 OK */ StructureObjectDto[];
export type GetAvailableStructureForSourceObjectUsingGetApiArg = {
  structureId: number;
  sourceObjectType: StructureType;
  name?: string;
};
export type GetSystemUsersUsingGetApiResponse =
  /** status 200 OK */ SystemUser[];
export type GetSystemUsersUsingGetApiArg = {
  structureId: number;
};
export type GetSystemUserUsingGetApiResponse = /** status 200 OK */ SystemUser;
export type GetSystemUserUsingGetApiArg = {
  structureId: number;
  /** SystemUser id */
  id: number;
};
export type GetUniversalColumnFromAllStructuresUsingGetApiResponse =
  /** status 200 OK */ ApiNodeColumnDto[];
export type GetUniversalColumnFromAllStructuresUsingGetApiArg = {
  structureId: number;
};
export type GetWriteColumnFromAllStructuresUsingGetApiResponse =
  /** status 200 OK */ ApiNodeColumnDto[];
export type GetWriteColumnFromAllStructuresUsingGetApiArg = {
  structureId: number;
};
export type GetAllSystemTechnologiesUsingGetApiResponse =
  /** status 200 OK */ TechnologyDto[];
export type GetAllSystemTechnologiesUsingGetApiArg = void;
export type SearchTableColumnsUsingGetApiResponse =
  /** status 200 OK */ AutocompleteResultDto[];
export type SearchTableColumnsUsingGetApiArg = {
  tableCode: string;
  searchText?: string;
  systemId: number;
  actualStructureId?: number;
};
export type SearchNodesWithTypeUsingGetApiResponse =
  /** status 200 OK */ AutocompleteResultDto[];
export type SearchNodesWithTypeUsingGetApiArg = {
  searchText: string;
  structureType: StructureType;
  systemId: number;
  actualStructureId?: number;
};
export type GetAsyncTasksUsingGetApiResponse =
  /** status 200 OK */ PageWrapperAsyncTaskExecutionDto;
export type GetAsyncTasksUsingGetApiArg = {
  state?: AsyncTaskState[];
  page?: number;
  pageSize?: number;
};
export type GetAsyncTasksByStructuredIdUsingGetApiResponse =
  /** status 200 OK */ PageWrapperAsyncTaskExecutionDto;
export type GetAsyncTasksByStructuredIdUsingGetApiArg = {
  structuredId: number;
  type?: AsyncTaskType;
  state?: AsyncTaskState[];
  page?: number;
  pageSize?: number;
};
export type CreateUsingPostApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type CreateUsingPostApiArg = {
  type: AsyncTaskType;
  body: {
    [key: string]: any;
  };
};
export type CancelTaskUsingDeleteApiResponse = unknown;
export type CancelTaskUsingDeleteApiArg = {
  id: number;
};
export type GetTaskExecutionUsingGetApiResponse =
  /** status 200 OK */ AsyncTaskExecutionDto;
export type GetTaskExecutionUsingGetApiArg = {
  id: number;
};
export type GetTaskResultFileUsingGetApiResponse = unknown;
export type GetTaskResultFileUsingGetApiArg = {
  id: number;
};
export type GetTaskResultUsingGetApiResponse = /** status 200 OK */ {
  [key: string]: any;
};
export type GetTaskResultUsingGetApiArg = {
  id: number;
};
export type GetAllTechnicalColumnsUsingGetApiResponse =
  /** status 200 OK */ TechnicalColumnDtoRead[];
export type GetAllTechnicalColumnsUsingGetApiArg = void;
export type CreateTechnicalColumnUsingPostApiResponse =
  /** status 201 Created */ TechnicalColumnDtoRead;
export type CreateTechnicalColumnUsingPostApiArg = {
  /** Update affected elements */
  updateElements?: boolean;
  technicalColumnDto: TechnicalColumnDto;
};
export type GetTechnicalColumnStereotypeUsingGetApiResponse =
  /** status 200 OK */ TechnicalColumnStereotypeDto[];
export type GetTechnicalColumnStereotypeUsingGetApiArg = {
  /** Stereotype id */
  stereotypeId: number;
  technologyId: number;
};
export type DeleteTechnicalColumnUsingDeleteApiResponse = unknown;
export type DeleteTechnicalColumnUsingDeleteApiArg = {
  /** Technical column id */
  technicalColumnId: number;
  /** Update affected elements */
  updateElements?: boolean;
};
export type UpdateTechnicalColumnUsingPutApiResponse =
  /** status 200 OK */ TechnicalColumnDtoRead;
export type UpdateTechnicalColumnUsingPutApiArg = {
  /** Technical column id */
  technicalColumnId: number;
  /** Update affected elements */
  updateElements?: boolean;
  technicalColumnDto: TechnicalColumnDto;
};
export type ComputeImpactTcChangeUsingPostApiResponse =
  /** status 200 OK */ ImpactChangeCodeListDto;
export type ComputeImpactTcChangeUsingPostApiArg = {
  /** Technical column id */
  technicalColumnId: number;
  technicalColumnDto: TechnicalColumnDto;
};
export type GetTablesByTechnicalColumnUsingGetApiResponse =
  /** status 200 OK */ StructureObjectDto[];
export type GetTablesByTechnicalColumnUsingGetApiArg = {
  /** Technical column id */
  technicalColumnId: number;
};
export type GetTablesByTechnicalColumnCsvUsingGetApiResponse =
  /** status 200 OK */ string;
export type GetTablesByTechnicalColumnCsvUsingGetApiArg = {
  /** Technical column id */
  technicalColumnId: number;
};
export type GetAllTechnologiesUsingGetApiResponse =
  /** status 200 OK */ TechnologyDto[];
export type GetAllTechnologiesUsingGetApiArg = void;
export type GetAllTemplatesV1UsingGetApiResponse =
  /** status 200 OK */ TemplateListDtoV1[];
export type GetAllTemplatesV1UsingGetApiArg = {
  /** Technology id */
  technologyId?: number;
  /** Stereotype id */
  stereotypeId?: number;
};
export type CreateTemplateV1UsingPostApiResponse =
  /** status 201 Created */ TemplateDtoV1;
export type CreateTemplateV1UsingPostApiArg = {
  templateDtoV1: TemplateDtoV1;
};
export type DeleteTemplateV1UsingDeleteApiResponse = unknown;
export type DeleteTemplateV1UsingDeleteApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateV1UsingGetApiResponse =
  /** status 200 OK */ TemplateDtoV1;
export type GetTemplateV1UsingGetApiArg = {
  /** Template id */
  id: number;
};
export type UpdateTemplateV1UsingPutApiResponse =
  /** status 200 OK */ TemplateDtoV1;
export type UpdateTemplateV1UsingPutApiArg = {
  /** Template id */
  id: number;
  templateDtoV1: TemplateDtoV1;
};
export type GetTemplateHistoryV1UsingGetApiResponse =
  /** status 200 OK */ TemplateListDtoV1[];
export type GetTemplateHistoryV1UsingGetApiArg = {
  /** Template id */
  id: number;
};
export type GetTemplateHistoryDetailV1UsingGetApiResponse =
  /** status 200 OK */ TemplateDtoV1;
export type GetTemplateHistoryDetailV1UsingGetApiArg = {
  /** Template id */
  id: number;
  /** Template version */
  version: number;
};
export type GetUsersUsingGetApiResponse = /** status 200 OK */ UserDtoRead[];
export type GetUsersUsingGetApiArg = void;
export type AddUserUsingPostApiResponse = /** status 200 OK */ UserDtoRead;
export type AddUserUsingPostApiArg = {
  newUserDto: NewUserDto;
};
export type GetApiUsersUsingGetApiResponse =
  /** status 200 OK */ ApiUserDtoRead[];
export type GetApiUsersUsingGetApiArg = void;
export type AddApiUserUsingPostApiResponse =
  /** status 200 OK */ ApiUserDtoRead;
export type AddApiUserUsingPostApiArg = {
  apiUserDto: ApiUserDto;
};
export type DeleteApiUserUsingDeleteApiResponse = unknown;
export type DeleteApiUserUsingDeleteApiArg = {
  clientId: string;
};
export type ApiUserUpdateUsingPostApiResponse =
  /** status 200 OK */ ApiUserDtoRead;
export type ApiUserUpdateUsingPostApiArg = {
  clientId: string;
  apiUserDto: ApiUserDto;
};
export type ApiUserResetSecretUsingPostApiResponse =
  /** status 200 OK */ ApiUserDtoRead;
export type ApiUserResetSecretUsingPostApiArg = {
  clientId: string;
};
export type GetUsersForComboUsingGetApiResponse =
  /** status 200 OK */ UserComboDto[];
export type GetUsersForComboUsingGetApiArg = void;
export type GetSessionContextUsingGetApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type GetSessionContextUsingGetApiArg = void;
export type UpdateSessionContextUsingPutApiResponse =
  /** status 200 OK */ SessionContextDtoRead;
export type UpdateSessionContextUsingPutApiArg = {
  sessionContextDto: SessionContextDto;
};
export type LockUserUsingPostApiResponse = /** status 200 OK */ UserMessageDto;
export type LockUserUsingPostApiArg = {
  /** User id */
  userId: number;
};
export type ResetUserPasswordUsingPostApiResponse = unknown;
export type ResetUserPasswordUsingPostApiArg = {
  resetPasswordDto: ResetPasswordDto;
};
export type UnlockUserUsingPostApiResponse =
  /** status 200 OK */ UserMessageDto;
export type UnlockUserUsingPostApiArg = {
  /** User id */
  userId: number;
};
export type DeleteUserUsingDeleteApiResponse = unknown;
export type DeleteUserUsingDeleteApiArg = {
  userId: number;
};
export type GetUserUsingGetApiResponse = /** status 200 OK */ UserDtoRead;
export type GetUserUsingGetApiArg = {
  userId: number;
};
export type EditUserUsingPutApiResponse = /** status 200 OK */ UserDtoRead;
export type EditUserUsingPutApiArg = {
  userId: number;
  editUserInfoDto: EditUserInfoDto;
};
export type GetUserRolesUsingGetApiResponse = /** status 200 OK */ UserRolesDto;
export type GetUserRolesUsingGetApiArg = {
  userId: number;
};
export type EditUserRolesUsingPutApiResponse =
  /** status 200 OK */ UserRolesDto;
export type EditUserRolesUsingPutApiArg = {
  userId: number;
  userRolesDto: UserRolesDto;
};
export type AdjustTableNameUsingPostApiResponse =
  /** status 200 OK */ AdjustResultDto;
export type AdjustTableNameUsingPostApiArg = {
  utilsNameRequestDto: UtilsNameRequestDto;
};
export type CheckUniqueNameUsingPostApiResponse =
  /** status 200 OK */ CheckResultDto;
export type CheckUniqueNameUsingPostApiArg = {
  utilsNameRequestDto: UtilsNameRequestDto;
};
export type CheckStructureUsingGetApiResponse =
  /** status 200 OK */ ValidationMessageDto[];
export type CheckStructureUsingGetApiArg = {
  structureId: number;
};
export type GetAllWorkflowTechnologiesUsingGetApiResponse =
  /** status 200 OK */ TechnologyDto[];
export type GetAllWorkflowTechnologiesUsingGetApiArg = void;
export type AcronymDto = {
  acronym: string;
  text: string;
};
export type AcronymDtoRead = {
  acronym: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  id?: number;
  text: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type PageableDtoAcronymDto = {
  acronyms?: AcronymDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type PageableDtoAcronymDtoRead = {
  acronyms?: AcronymDtoRead[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type AcronymCreateDto = {
  acronym: string;
  text: string;
};
export type AcronymUpdateDto = {
  acronym: string;
  text: string;
};
export type UserType = "STANDARD" | "ADMIN" | "READER" | "API";
export type User = {
  api?: boolean;
  company?: number;
  companyId?: number;
  department?: string;
  description?: string;
  email: string;
  extId?: string;
  id?: number;
  loginName: string;
  name: string;
  owner?: User;
  sessionContext?: string;
  support?: boolean;
  surname: string;
  type?: UserType;
};
export type EntityType =
  | "aggregate"
  | "auxiliary"
  | "composition"
  | "fundamental"
  | "metadata"
  | "relation"
  | "snapshot"
  | "specialisation"
  | "transaction";
export type OperationType =
  | "LOCK"
  | "UNLOCK"
  | "FORCE_UNLOCK"
  | "UPDATE_DATA"
  | "UPDATE"
  | "CREATE"
  | "DELETE"
  | "RESTORE"
  | "UPDATE_ACL";
export type StructureAudit = {
  author: User;
  created: string;
  description: string;
  entityId: number;
  entityType: EntityType;
  id?: number;
  operationType: OperationType;
  plainDataAfter?: string;
  plainDataBefore?: string;
  relatedPerson?: User;
};
export type BusinessDomainDto = {
  description?: string;
  name: string;
};
export type BusinessDomainDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type BusinessDomainComboDto = {
  companyName: string;
  description?: string;
  id?: number;
  name: string;
};
export type Company = {
  id?: number;
  information?: string;
  name: string;
};
export type StructureTypeDto = {
  code: string;
};
export type LovReference = {
  code?: string;
  id: number;
};
export type LovReferenceRead = {
  code?: string;
  id: number;
  name?: string;
};
export type CustomAttributeStructureTypeEnum =
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "TABLE_COLUMN"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE";
export type CustomAttributeTypeEnum =
  | "STRING"
  | "SCRIPT"
  | "NUMBER"
  | "BOOLEAN"
  | "LOV"
  | "ARRAY";
export type CustomAttributeDto = {
  customLovId?: number;
  description?: string;
  group?: LovReference;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
};
export type CustomAttributeDtoRead = {
  createdAt?: string;
  createdBy?: string;
  customLovId?: number;
  deleted?: boolean;
  description?: string;
  group?: LovReferenceRead;
  id?: number;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type CustomAttributeCreateDto = {
  customLovId?: number;
  description?: string;
  id?: number;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  version?: number;
};
export type CustomLovValueComboDto = {
  label?: string;
  ordering?: number;
  value?: string;
};
export type CustomAttributeComboDto = {
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  version?: number;
};
export type CustomAttributeUpdateDto = {
  customLovId?: number;
  description?: string;
  id?: number;
  name: string;
  ordering?: number;
  regex?: string;
  stereotypeIds?: number[];
  structureTypes?: CustomAttributeStructureTypeEnum[];
  type: CustomAttributeTypeEnum;
  version?: number;
};
export type CustomLovDto = {
  description?: string;
  lovValues?: CustomLovValueComboDto[];
  name: string;
};
export type CustomLovDtoRead = {
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type CustomLovCreateDto = {
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  version?: number;
};
export type CustomLovComboDto = {
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  version?: number;
};
export type CustomLovUpdateDto = {
  description?: string;
  id?: number;
  lovValues?: CustomLovValueComboDto[];
  name: string;
  version?: number;
};
export type SqlType =
  | "TABLE_HISTORY"
  | "TABLE_REFERENCE"
  | "TABLE"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "FOLDER";
export type DeploymentDto = {
  authorId: number;
  authorName: string;
  created: string;
  description: string;
  environmentCode?: string;
  environmentFeId: number;
  environmentId: number;
  id: number;
  releaseId?: number;
  sqlType: SqlType;
  structureHistoryId: number;
  structureId: number;
  templateId: number;
  version: number;
};
export type DeploymentNewDto = {
  data: string;
  description: string;
  sqlType?: SqlType;
  structureHistoryId: number;
  templateId: number;
};
export type DeploymentDetailDto = {
  authorId: number;
  authorName: string;
  created: string;
  data: string;
  description: string;
  environmentCode?: string;
  environmentFeId: number;
  environmentId: number;
  id: number;
  releaseId?: number;
  sqlType: SqlType;
  structureHistoryId: number;
  structureId: number;
  templateId: number;
  version: number;
};
export type DataTypeEnum = "STRING" | "NUMBER" | "BOOLEAN" | "DATETIME";
export type DomainTechnologyDto = {
  dataType: string;
  defaultValue?: string;
  id: number;
  technologyCode: string;
  technologyId?: number;
};
export type DomainDto = {
  code: string;
  companyName: string;
  createdAt?: string;
  createdBy?: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  deleted?: boolean;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DomainCreateDto = {
  code: string;
  companyName: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type DomainComboDto = {
  code: string;
  companyName: string;
  createdAt?: string;
  createdBy?: string;
  custom: boolean;
  deleted?: boolean;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type DomainUpdateDto = {
  code: string;
  companyName: string;
  custom: boolean;
  dataType?: DataTypeEnum;
  description?: string;
  domainTechnologies?: DomainTechnologyDto[];
  hasTemplate: boolean;
  id: number;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type ImpactedColumnDto = {
  columnCode?: string;
  columnName?: string;
  columnUuid?: string;
  tableCode?: string;
  tableId?: number;
  tableName?: string;
};
export type ImpactChangeCodeListDto = {
  affectedElements?: {
    [key: string]: number;
  };
};
export type UserDto = {
  department?: string;
  description?: string;
  email: string;
  loginName: string;
  name: string;
  surname: string;
  type?: UserType;
};
export type UserDtoRead = {
  canBeEdited?: boolean;
  companyName?: string;
  compositeName?: string;
  deleted?: boolean;
  department?: string;
  description?: string;
  email: string;
  hardLock?: boolean;
  id?: number;
  loginName: string;
  name: string;
  support?: boolean;
  surname: string;
  type?: UserType;
};
export type ReleaseStatusEnum = "OPEN" | "CANCEL" | "COMPLETED";
export type ReleaseDto = {
  description?: string;
  name?: string;
  responsibleUser?: UserDto;
  status?: ReleaseStatusEnum;
};
export type ReleaseDtoRead = {
  canEditWholeContent?: boolean;
  canReadWholeContent?: boolean;
  description?: string;
  id?: number;
  name?: string;
  responsibleUser?: UserDtoRead;
  status?: ReleaseStatusEnum;
};
export type ReleaseDtoWrite = {
  description?: string;
  name?: string;
  responsibleUser?: UserDto;
  responsibleUserId?: number;
  status?: ReleaseStatusEnum;
};
export type EnvironmentDto = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  lastRelease?: ReleaseDto;
  name: string;
  production?: boolean;
  rememberPassword?: boolean;
};
export type EnvironmentDtoRead = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  lastRelease?: ReleaseDtoRead;
  name: string;
  production?: boolean;
  rememberPassword?: boolean;
};
export type EnvironmentDtoWrite = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  lastRelease?: ReleaseDtoWrite;
  name: string;
  production?: boolean;
  rememberPassword?: boolean;
};
export type StructureType =
  | "ROOT"
  | "SYSTEM"
  | "FOLDER"
  | "FOLDER_WORKFLOW"
  | "TABLE"
  | "MAPPING_DEFAULT"
  | "MAPPING"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "WORKFLOW"
  | "VIEW"
  | "API_NODE"
  | "API_COLLECTION"
  | "QUEUE"
  | "CONSTANT_DOMAIN"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type ObjectSettingsDto = {
  code: string;
  comment?: string;
  defaultFlag?: boolean;
  description?: string;
  name: string;
  structureType?: StructureType;
};
export type ObjectSettingsDtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  defaultFlag?: boolean;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  structureType?: StructureType;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type EnvironmentDeploymentDto = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  key?: number;
  lastDeploymentAuthorCompositeName?: string;
  lastDeploymentAuthorId?: number;
  lastDeploymentStructureHistoryId?: number;
  lastDeploymentStructureHistoryVersion?: number;
  lastRelease?: ReleaseDto;
  name: string;
  objectType?: ObjectSettingsDto;
  production?: boolean;
  rememberPassword?: boolean;
};
export type EnvironmentDeploymentDtoRead = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  key?: number;
  lastDeploymentAuthorCompositeName?: string;
  lastDeploymentAuthorId?: number;
  lastDeploymentStructureHistoryId?: number;
  lastDeploymentStructureHistoryVersion?: number;
  lastRelease?: ReleaseDtoRead;
  name: string;
  objectType?: ObjectSettingsDtoRead;
  production?: boolean;
  rememberPassword?: boolean;
};
export type EnvironmentDeploymentDtoWrite = {
  code: string;
  connection?: string;
  description?: string;
  directDeployment?: boolean;
  frontendId: number;
  gitLoginName?: string;
  gitPasswordToken?: string;
  gitUrl?: string;
  id: number;
  key?: number;
  lastDeploymentAuthorCompositeName?: string;
  lastDeploymentAuthorId?: number;
  lastDeploymentStructureHistoryId?: number;
  lastDeploymentStructureHistoryVersion?: number;
  lastRelease?: ReleaseDtoWrite;
  name: string;
  objectType?: ObjectSettingsDto;
  production?: boolean;
  rememberPassword?: boolean;
};
export type ReturnMessageTypeEnum =
  | "INCOMPATIBLE_TARGET"
  | "CUSTOM_ATTRIBUTE_NOT_FOUND"
  | "OBJECT_SETTING_NOT_FOUND"
  | "OWNER_NOT_FOUND"
  | "BUSINESS_DOMAIN_NOT_FOUND"
  | "RESPONSIBLE_ANALYST_NOT_FOUND"
  | "RESPONSIBLE_PERSON_NOT_FOUND"
  | "DOMAIN_NOT_FOUND"
  | "STEREOTYPE_NOT_FOUND"
  | "TABLE_ALREADY_EXISTS"
  | "INCONSISTENT_TABLES"
  | "INCONSISTENT_DOMAINS"
  | "COLUMN_WITH_SAME_NAME_ALREADY_EXISTS"
  | "COLUMN_WITH_SAME_CODE_ALREADY_EXISTS"
  | "DUPLICATE_COLUMN_NAME"
  | "DUPLICATE_COLUMN_CODE"
  | "TECHNICAL_COLUMN_COLLISION"
  | "SYSTEM_USER_NOT_FOUND";
export type ReturnMessage = {
  detail?: string;
  messageType?: ReturnMessageTypeEnum;
  object?: string;
};
export type CheckResult = {
  errors?: ReturnMessage[];
  warnings?: ReturnMessage[];
};
export type ExistingElementsEnum = "OVERWRITE" | "MERGE";
export type FkMissingTable = "IGNORE" | "IMPORT";
export type FkMoreTables = "IGNORE" | "IMPORT_EXITING" | "IMPORT_IMPORTED";
export type StructureExportDto = {
  actualData?: string;
  children?: StructureExportDto[];
  code?: string;
  name?: string;
  type?: StructureType;
};
export type Id = {
  code?: string;
  id?: number;
  name?: string;
  originalId?: number;
  originalUuid?: string;
  type?: StructureType;
  uuid?: string;
};
export type Structure = {
  data?: any;
  id?: Id;
  locked?: boolean;
  parentId?: Id;
  type?: StructureType;
};
export type InitInfoDto = {
  allowed?: boolean;
  goJSLicenseKey?: string;
};
export type BusinessDomainCreateDto = {
  description?: string;
  name: string;
};
export type CustomAttribute = {
  id?: string;
  name?: string;
  source?: string;
  value?: any;
  version?: string;
};
export type CustomLov = {
  description?: string;
  lovValues?: CustomLovValueComboDto[];
  name?: string;
};
export type DomainTechnology = {
  dataType: string;
  defaultValue?: string;
  technologyCode: string;
};
export type Domain = {
  code: string;
  custom: boolean;
  description?: string;
  domainTechnologies?: DomainTechnology[];
  hasTemplate: boolean;
  length?: string;
  name: string;
  notNullFlag?: boolean;
  template?: string;
  templateValueFormat?: string;
  templateValueRegex?: string;
  textValueFlag?: boolean;
};
export type ExpectationProviderDto = {
  code: string;
  description?: string;
  name: string;
  providerVersion: string;
};
export type ExpectationProviderDtoRead = {
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  id?: number;
  name: string;
  providerVersion: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type ExpectationGroupCode =
  | "RANGE"
  | "SETS_AND_LISTS"
  | "PATTERNS"
  | "BASIC";
export type ExpectationAdminDto = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  name: string;
  providerId: number;
  templateText: string;
};
export type ExpectationAdminDtoRead = {
  active: boolean;
  allowedDataTypes: DataTypeEnum[];
  code: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  expectationType: string;
  groupCode: ExpectationGroupCode;
  id?: number;
  name: string;
  providerCode?: string;
  providerId: number;
  templateText: string;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type ObjectSettingsCreateDto = {
  code: string;
  comment?: string;
  description?: string;
  id: number;
  name: string;
  structureType?: StructureType;
};
export type ObjectSettingsCreateDtoRead = {
  code: string;
  comment?: string;
  defaultFlag?: boolean;
  description?: string;
  id: number;
  name: string;
  structureType?: StructureType;
};
export type StereotypeCategory = "BEHAVIORAL" | "DEFAULT" | "USER_DEFINED";
export type StereotypeType =
  | "FOLDER"
  | "TABLE"
  | "TABLE_INTERFACE"
  | "TABLE_HISTORY"
  | "COLUMN"
  | "MAPPING"
  | "MAPPING_TYPE"
  | "MAPPING_READ"
  | "MAPPING_WRITE"
  | "CONSTANT_DOMAIN"
  | "VIEW"
  | "WORKFLOW"
  | "API_NODE"
  | "API_NODE_ATTRIBUTE"
  | "API_ROWSET"
  | "QUEUE"
  | "TABLE_COLUMN"
  | "DIAGRAM";
export type StereotypeDto = {
  category: StereotypeCategory;
  children?: StereotypeDto[];
  code: string;
  description?: string;
  hasSubtypes: boolean;
  id: number;
  internal?: boolean;
  name: string;
  type: StereotypeType;
};
export type TechnicalColumn = {
  code: string;
  comment?: string;
  description?: string;
  domainCode: string;
  name: string;
  ordering?: number;
  stereotypeCodes?: string[];
  stereotypeColumnCode?: string;
  virtualColumnScript?: string;
};
export type CodeList = {
  businessDomains?: BusinessDomainCreateDto[];
  customAttributes?: CustomAttribute[];
  customLovs?: CustomLov[];
  domains?: Domain[];
  expectationProviders?: ExpectationProviderDto[];
  expectations?: ExpectationAdminDto[];
  objectTypes?: ObjectSettingsCreateDto[];
  stereotypes?: StereotypeDto[];
  technicalColumns?: TechnicalColumn[];
};
export type CodeListRead = {
  businessDomains?: BusinessDomainCreateDto[];
  customAttributes?: CustomAttribute[];
  customLovs?: CustomLov[];
  domains?: Domain[];
  expectationProviders?: ExpectationProviderDtoRead[];
  expectations?: ExpectationAdminDtoRead[];
  objectTypes?: ObjectSettingsCreateDtoRead[];
  stereotypes?: StereotypeDto[];
  technicalColumns?: TechnicalColumn[];
};
export type CodeListType =
  | "OBJECT_TYPE"
  | "STEREOTYPE"
  | "BUSINESS_DOMAIN"
  | "DOMAIN"
  | "TECHNICAL_COLUMN"
  | "CUSTOM_ATTRIBUTE"
  | "EXPECTATION";
export type UserMonthlyReportDto = {
  email?: string;
  loginName?: string;
  name?: string;
  registeredFrom?: string;
  registeredTo?: string;
  surname?: string;
  userType?: UserType;
};
export type UserInfoDto = {
  id: number;
};
export type UserInfoDtoRead = {
  email?: string;
  fullName?: string;
  id: number;
  loginName?: string;
};
export type FormatType = "PYTHON" | "SQL" | "PLAIN_TEXT";
export type ReferenceObjectInfo = {
  code?: string;
  id: number;
  uuid?: string;
};
export type ReferenceObjectInfoRead = {
  code?: string;
  id: number;
  name?: string;
  uuid?: string;
};
export type TemplateDto = {
  author?: UserInfoDto;
  comment?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type AdjustResultDto = {
  result: string;
};
export type NamingTypeEnum =
  | "TABLE_CODE"
  | "MAPPING_CODE"
  | "INTERFACE_CODE"
  | "VIEW_CODE"
  | "API_NODE_CODE"
  | "API_COLLECTION_CODE"
  | "FOLDER_CODE"
  | "QUEUE_CODE"
  | "SYSTEM_CODE"
  | "WORKFLOW_CODE"
  | "HISTORICAL_TABLE_NAME"
  | "REFERENCE_TABLE_NAME"
  | "HISTORICAL_TABLE_CODE"
  | "REFERENCE_TABLE_CODE"
  | "HISTORICAL_DEFAULT_MAPPING_NAME"
  | "REFERENCE_DEFAULT_MAPPING_NAME"
  | "INTERFACE_DEFAULT_MAPPING_NAME"
  | "HISTORICAL_DEFAULT_MAPPING_CODE"
  | "REFERENCE_DEFAULT_MAPPING_CODE"
  | "INTERFACE_DEFAULT_MAPPING_CODE"
  | "DEFAULT_MAPPING_NAME"
  | "DEFAULT_MAPPING_CODE"
  | "DDL_SCRIPT_NAME"
  | "EXPORT_NAME"
  | "PRIMARY_KEY_NAME"
  | "SEQUENCE_NAME";
export type NamingDto = {
  companyName?: string;
  createdAt?: string;
  createdBy?: string;
  defaultTemplate?: string;
  deleted?: boolean;
  template?: string;
  type?: NamingTypeEnum;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type TableColumnDomain = {
  code?: string;
  id?: number;
  name?: string;
};
export type DefinitionKind =
  | "odcs_library"
  | "sql"
  | "expectation"
  | "free_text";
export type Dimension =
  | "accuracy"
  | "completeness"
  | "conformity"
  | "consistency"
  | "coverage"
  | "timeliness"
  | "uniqueness";
export type ExpectationDefinitionRef = {
  code?: string;
  providerCode?: string;
};
export type Kwargs = any;
export type Representation = any;
export type Expectation = {
  definition?: ExpectationDefinitionRef;
  kwargs?: Kwargs;
  representation?: Representation;
};
export type Arguments = any;
export type OdcsLibrary = {
  arguments?: Arguments;
  metric?: string;
  operator?: string;
};
export type Severity = "error" | "warning" | "info";
export type DqRuleSql = {
  operator?: any;
  query?: string;
};
export type DqRule = {
  definitionKind?: DefinitionKind;
  description?: string;
  dimension?: Dimension;
  expectation?: Expectation;
  freeText?: string;
  library?: OdcsLibrary;
  name?: string;
  severity?: Severity;
  sql?: DqRuleSql;
  uuid?: string;
};
export type TableColumnStereotype = {
  code?: string;
  id?: number;
  name?: string;
};
export type TableColumn = {
  code?: string;
  comment?: string;
  customAttributes?: CustomAttribute[];
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domain?: TableColumnDomain;
  foreignKey?: boolean;
  g_hasTemplate?: boolean;
  g_isTextValue?: boolean;
  g_template?: string;
  ghasTemplate?: boolean;
  gisTextValue?: boolean;
  gtemplate?: string;
  historyColumn?: boolean;
  id?: number;
  mandatory?: boolean;
  name?: string;
  notNull?: boolean;
  notNullFlag?: boolean;
  odcsDqRules?: DqRule[];
  order?: number;
  primaryKey?: boolean;
  stereotype?: TableColumnStereotype;
  stereotypeColumn?: boolean;
  technicalColumnId?: number;
  uuid?: string;
  virtualColumnScript?: string;
};
export type TableConstraintColumn = {
  code?: string;
  foreignColumnCode?: string;
  foreignColumnUuid?: string;
  name?: string;
  order?: number;
  uuid?: string;
};
export type ConstraintType =
  | "primary_key"
  | "foreign_key"
  | "custom"
  | "unique"
  | "check";
export type Cardinality =
  | "ONE"
  | "MANY"
  | "ONE_ONLY"
  | "ONE_OR_MANY"
  | "ZERO_OR_ONE"
  | "ZERO_OR_MANY";
export type TableConstraint = {
  code?: string;
  columns?: TableConstraintColumn[];
  comment?: string;
  constraintType?: ConstraintType;
  description?: string;
  enabled?: boolean;
  expression?: string;
  foreignKeyTableId?: number;
  foreignKeyTableUuid?: string;
  g_foreignKeyTableCode?: string;
  g_foreignKeyTableOwner?: string;
  gforeignKeyTableCode?: string;
  gforeignKeyTableOwner?: string;
  id?: number;
  name?: string;
  order?: number;
  physicalOptions?: string;
  script?: string;
  sourceCardinality?: Cardinality;
  targetCardinality?: Cardinality;
};
export type SortType = "ASC" | "DESC";
export type TableIndexColumn = {
  code?: string;
  order?: number;
  sortType?: SortType;
  uuid?: string;
};
export type TableIndex = {
  code?: string;
  columns?: TableIndexColumn[];
  comment?: string;
  description?: string;
  id?: number;
  isUnique?: boolean;
  name?: string;
  order?: number;
  physicalOptions?: string;
};
export type NonSyncFieldTable =
  | "uuid"
  | "name"
  | "code"
  | "comment"
  | "description"
  | "stereotypeId"
  | "stereotypeCode"
  | "subStereotypeId"
  | "hasHistoryTable"
  | "hasReferenceTable"
  | "businessDomainId"
  | "businessDomainName"
  | "entityType"
  | "status"
  | "responsibleAnalystId"
  | "responsibleAnalystName"
  | "responsiblePersonId"
  | "responsiblePersonName"
  | "retentionStrategy"
  | "retentionStrategyFullHistoryValue"
  | "retentionStrategyFullHistoryUnit"
  | "retentionStrategyEomValue"
  | "retentionStrategyEomUnit"
  | "columns"
  | "columnsLastId"
  | "indexes"
  | "indexesLastId"
  | "constraints"
  | "constraintsLastId"
  | "historyTable"
  | "referenceTable"
  | "script"
  | "preTableScript"
  | "postTableScript"
  | "partitioningStrategy"
  | "partitioningColumnId"
  | "partitioningColumnCode"
  | "sequenceCode"
  | "sequenceColumnCode"
  | "ownerId"
  | "ownerName"
  | "objectSettings"
  | "customAttributes";
export type TablePermissionEnum =
  | "ALTER"
  | "SELECT"
  | "DELETE"
  | "UPDATE"
  | "INSERT"
  | "REFERENCE"
  | "SEQUENCE";
export type SystemUser = {
  code?: string;
  comment?: string;
  description?: string;
  id?: number;
  name?: string;
};
export type TablePermission = {
  id?: number;
  order?: number;
  permissions?: TablePermissionEnum[];
  user?: SystemUser;
};
export type ObjectSettings = {
  code?: string;
  id?: number;
  name?: string;
};
export type Parent = {
  code?: string;
  name?: string;
};
export type PartitioningStrategyHistoryTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective"
  | "source_system_and_valid_to";
export type RetentionStrategy =
  | "infinite"
  | "delete_after"
  | "move_after"
  | "keep_full_history"
  | "keep_full_history_and_eom";
export type RetentionTimeUnit = "day" | "month" | "year";
export type Status =
  | "logical_in_progress"
  | "logical_completed"
  | "physical_in_progress"
  | "physical_completed"
  | "frozen";
export type HistoryTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isHistoryTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisHistoryTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyHistoryTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type PartitioningStrategyTable =
  | "no_partition"
  | "key"
  | "source_system"
  | "snapshot_data"
  | "source_and_snapshot"
  | "key_and_snapshot"
  | "source_and_snapshot_and_date_effective"
  | "key_and_snapshot_and_date_effective";
export type ReferenceTable = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_isReferenceTable?: boolean;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gisReferenceTable?: boolean;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  nonSyncFields?: NonSyncFieldTable[];
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  originalTable?: Parent;
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type Table = {
  businessDomainId?: number;
  businessDomainName?: string;
  code?: string;
  columns?: TableColumn[];
  columnsLastId?: number;
  comment?: string;
  constraints?: TableConstraint[];
  constraintsLastId?: number;
  customAttributes?: CustomAttribute[];
  description?: string;
  entityType?: EntityType;
  g_partitioningColumnCode?: string;
  g_templateStereotype?: string;
  g_templateVersion?: number;
  gpartitioningColumnCode?: string;
  gtemplateStereotype?: string;
  gtemplateVersion?: number;
  hasHistoryTable?: boolean;
  hasReferenceTable?: boolean;
  historyTable?: HistoryTable;
  indexes?: TableIndex[];
  indexesLastId?: number;
  name?: string;
  objectPermissionLastId?: number;
  objectPermissions?: TablePermission[];
  objectSettings?: ObjectSettings[];
  odcsDqRules?: DqRule[];
  ownerId?: number;
  ownerName?: string;
  partitioningColumnCode?: string;
  partitioningColumnId?: number;
  partitioningStrategy?: PartitioningStrategyTable;
  postTableScript?: string;
  preTableScript?: string;
  referenceTable?: ReferenceTable;
  responsibleAnalystId?: number;
  responsibleAnalystName?: string;
  responsiblePersonId?: number;
  responsiblePersonName?: string;
  retentionStrategy?: RetentionStrategy;
  retentionStrategyEomUnit?: RetentionTimeUnit;
  retentionStrategyEomValue?: number;
  retentionStrategyFullHistoryUnit?: RetentionTimeUnit;
  retentionStrategyFullHistoryValue?: number;
  script?: string;
  sequenceCode?: string;
  sequenceColumnCode?: string;
  status?: Status;
  stereotypeCode?: string;
  stereotypeId?: number;
  subStereotypeId?: number;
  uuid?: string;
};
export type StructureWorkingDataDto = {
  data: string;
};
export type ObjectSettingsComboDto = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  defaultFlag?: boolean;
  deleted?: boolean;
  description?: string;
  id: number;
  name: string;
  structureType?: StructureType;
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
};
export type ObjectSettingsUpdateDto = {
  code: string;
  comment?: string;
  description?: string;
  id: number;
  name: string;
  structureType?: StructureType;
};
export type Permission = "VIEW" | "EDIT" | "MANAGE_ACCESS" | "FORCE_UNLOCK";
export type PermissionType = "NODE" | "GLOBAL";
export type RelationColumnDto = {
  code?: string;
  uuid?: string;
};
export type StructureReferenceInfoDto = {
  code?: string;
  fullPath?: string;
  id?: number;
  name?: string;
  type?: StructureType;
  uuid?: string;
};
export type RelationType =
  | "PK_FK_TABLE"
  | "PK_FK_COLUMN"
  | "MAPPING_WRITE"
  | "LINK"
  | "LINK_COLUMN"
  | "CUSTOM_LINK";
export type RelationStatus =
  | "OK"
  | "PK_SIDE_REMOVED"
  | "FK_COL_NOT_SET"
  | "PK_COL_REMOVED"
  | "BROKEN";
export type RelationDto = {
  children?: RelationDto[];
  code?: string;
  description?: string;
  hasChildren?: boolean;
  id?: number;
  leftSideColumn?: RelationColumnDto;
  leftSideStructure?: StructureReferenceInfoDto;
  name?: string;
  parentRelationId?: number;
  relationType?: RelationType;
  rightSideColumn?: RelationColumnDto;
  rightSideStructure?: StructureReferenceInfoDto;
  status?: RelationStatus;
};
export type StereotypeCategoryDto = {
  code: string;
};
export type StereotypeTypeDto = {
  code: string;
};
export type StereotypeCreateDto = {
  category: StereotypeCategory;
  children?: StereotypeCreateDto[];
  code: string;
  description?: string;
  hasSubtypes: boolean;
  name: string;
  type: StereotypeType;
};
export type StereotypeUpdateDto = {
  category: StereotypeCategory;
  children?: StereotypeUpdateDto[];
  code: string;
  description?: string;
  hasSubtypes: boolean;
  id: number;
  internal?: boolean;
  name: string;
  type: StereotypeType;
};
export type StructureDto = {
  authorId?: number;
  authorName?: string;
  canEdit: boolean;
  code: string;
  companyId: number;
  description?: string;
  fullPath?: string;
  hasChildren: boolean;
  id: number;
  lockTime?: string;
  lockUserId?: number;
  lockUserName?: string;
  name: string;
  orderPriority?: number;
  parentStructureId?: number;
  status?: string;
  type: StructureType;
  uuid?: string;
};
export type NewStructureDto = {
  data: string;
  type: StructureType;
};
export type FullTextSearchDto = {
  code?: string;
  created?: string;
  id?: number;
  name?: string;
  path?: string;
  rank?: number;
  type?: StructureType;
};
export type CsvImportExistingDomainDto = {
  code?: string;
  customFlag?: boolean;
  dataType?: string;
  defaultValue?: string;
  domainName?: string;
  id?: number;
  notNullFlag?: boolean;
};
export type CsvImportDomainDto = {
  dataType?: string;
  defaultValue?: string;
  domainName?: string;
  mandatoryFlag?: boolean;
  matchedDomain?: CsvImportExistingDomainDto;
  similarDomain?: CsvImportExistingDomainDto[];
};
export type ImportReturnMessageTypeEnum =
  | "INCOMPATIBLE_TARGET"
  | "DOMAIN_NOT_FOUND"
  | "STEREOTYPE_NOT_FOUND"
  | "TABLE_STEREOTYPE_NOT_FOUND"
  | "TABLE_ALREADY_EXISTS_IN_FOLDER"
  | "TABLE_ALREADY_EXISTS_IN_SYSTEM"
  | "INCONSISTENT_TABLES"
  | "INCONSISTENT_DOMAINS"
  | "COLUMN_WITH_SAME_NAME_ALREADY_EXISTS"
  | "COLUMN_WITH_SAME_CODE_ALREADY_EXISTS"
  | "DUPLICATE_COLUMN_NAME"
  | "DUPLICATE_COLUMN_CODE";
export type ImportReturnMessage = {
  messageType?: ImportReturnMessageTypeEnum;
  object?: string;
};
export type CsvImportColumnDto = {
  code?: string;
  comment?: string;
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domainCode?: string;
  domainId?: number;
  indexName?: string;
  name?: string;
  notNullFlag?: boolean;
  primaryKeyName?: string;
  stereoTypeId?: number;
  stereotypeCode?: string;
};
export type CsvImportTableDto = {
  code?: string;
  columnDtoList?: CsvImportColumnDto[];
  comment?: string;
  description?: string;
  name: string;
  postScript?: string;
  preScript?: string;
  script?: string;
  stereotypeCode?: string;
  stereotypeId?: number;
};
export type TechnicalColumnStereotypeDto = {
  code: string;
  columnStereotypeCode: string;
  columnStereotypeId: number;
  columnStereotypeName: string;
  comment?: string;
  dataType: string;
  defaultValue: string;
  description?: string;
  domainCode: string;
  domainId: number;
  domainName: string;
  id: number;
  name: string;
  notNull: boolean;
  ordering: number;
  virtualColumnScript?: string;
};
export type CsvImportReturnDto = {
  domainDtoList?: CsvImportDomainDto[];
  errors?: ImportReturnMessage[];
  tableDtos?: CsvImportTableDto[];
  technicalColumnMap?: {
    [key: string]: TechnicalColumnStereotypeDto[];
  };
  warnings?: ImportReturnMessage[];
};
export type NameNormalisationEnum =
  | "NONE"
  | "UPPERCASE_FIRST_CHARS"
  | "UPPERCASE_ALL";
export type ImportColumn = {
  code?: string;
  comment?: string;
  dataType?: string;
  defaultValue?: string;
  description?: string;
  domainName?: string;
  indexName?: string;
  mandatoryFlag?: boolean;
  name: string;
  order?: number;
  primaryKeyName?: string;
  stereotypeCode?: string;
};
export type ImportTable = {
  code?: string;
  comment?: string;
  description?: string;
  name: string;
  postScript?: string;
  preScript?: string;
  script?: string;
  stereotypeCode?: string;
};
export type CsvImportRowDto = {
  column: ImportColumn;
  table: ImportTable;
};
export type MddError = {
  errorCode?: string;
  errorDescription?: string;
  errorMessage?: string;
};
export type MassExportSorting =
  | "DEFAULT"
  | "SORT_BY_NAME_ASC"
  | "SORT_BY_TYPE_AND_NAME_ASC";
export type MassExportStrategy =
  | "ZIP_PER_STRUCTURE"
  | "ZIP_OWNER_FOLDER_PER_OBJECT_TYPE"
  | "ZIP_PER_OWNER_AND_OBJECT_TYPE"
  | "SINGLE_FILE";
export type StructureObjectPair = {
  objectType?: ObjectSettingsDto;
  structureType?: StructureType;
};
export type StructureObjectPairRead = {
  objectType?: ObjectSettingsDtoRead;
  structureType?: StructureType;
};
export type MassExportConfigDto = {
  /** frontend environment Id */
  environmentId?: number;
  /** Sorting of the exported data. */
  massExportSorting?: MassExportSorting;
  /** Strategy of the exported data. */
  massExportStrategy?: MassExportStrategy;
  /** List of structure ids to be exported. */
  structureIds?: number[];
  /** List of object types to be exported. */
  structureObjectPairs?: StructureObjectPair[];
  /** List of structure statuses to be exported. */
  structureStatus?: Status[];
  /** Timestamp of the structure version to be exported. */
  structureTimestamp?: string;
  /** Timestamp of the template version to be exported. */
  templateTimestamp?: string;
};
export type MassExportConfigDtoRead = {
  /** frontend environment Id */
  environmentId?: number;
  ignoreErrors?: boolean;
  /** Sorting of the exported data. */
  massExportSorting?: MassExportSorting;
  /** Strategy of the exported data. */
  massExportStrategy?: MassExportStrategy;
  /** List of structure ids to be exported. */
  structureIds?: number[];
  /** List of object types to be exported. */
  structureObjectPairs?: StructureObjectPairRead[];
  /** List of structure statuses to be exported. */
  structureStatus?: Status[];
  /** Timestamp of the structure version to be exported. */
  structureTimestamp?: string;
  /** Timestamp of the template version to be exported. */
  templateTimestamp?: string;
};
export type StructureSearchedDto = {
  children: StructureSearchedDto[];
  code?: string;
  hasChildren?: boolean;
  id: number;
  lockTime?: string;
  lockUserId?: number;
  lockUserName?: string;
  name: string;
  orderPriority?: number;
  parentStructureId?: number;
  searchedItem?: boolean;
  type: StructureType;
  uuid?: string;
};
export type StructureObjectDto = {
  code?: string;
  fullPath?: string;
  name?: string;
  parentStructureId?: number;
  structureId?: number;
  structureUuid?: string;
  type?: StructureType;
};
export type NodeType =
  | "SYSTEM_NODE"
  | "FOLDER"
  | "WORKFLOW"
  | "TABLE"
  | "MAPPING"
  | "VIEW"
  | "API"
  | "QUEUE";
export type ReleaseEnvironmentDto = {
  code?: string;
  id?: number;
  name?: string;
  releaseDate?: string;
  released?: boolean;
  releasedTime?: string;
};
export type DeploymentInfo = {
  deployedHistoryId?: number;
  deployedVersion?: number;
  id?: string;
  objectTypeCode?: string;
  pushedHistoryId?: number;
  pushedVersion?: number;
};
export type EnvInfo = {
  deploymentInfo?: DeploymentInfo[];
  envCode?: string;
  frontendId?: number;
};
export type StructureReleaseInfoDto = {
  code?: string;
  deleted?: boolean;
  environmentInfo?: EnvInfo[];
  fullPath?: string;
  name?: string;
  parentStructureId?: number;
  permissions?: Permission[];
  structureId?: number;
  type?: StructureType;
};
export type PageWrapperStructureReleaseInfoDto = {
  content?: StructureReleaseInfoDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type StructureUserPermissionDto = {
  inheritedPermissionCode: string;
  inheritedPermissionName: string;
  structurePermissionCode?: string;
  structurePermissionName?: string;
  userId: number;
  userLoginName: string;
};
export type StructureDetailDto = {
  authorId?: number;
  authorName?: string;
  canEdit: boolean;
  code: string;
  companyId: number;
  data?: string;
  hasChildren: boolean;
  id: number;
  lockTime?: string;
  lockUserId?: number;
  lockUserName?: string;
  name: string;
  orderPriority?: number;
  parentStructureId?: number;
  status?: string;
  stereotypeId?: number;
  stereotypeName?: string;
  subStereotypeId?: number;
  subStereotypeName?: string;
  systemTechnologyId?: number;
  systemTechnologyName?: string;
  type: StructureType;
  usersPermissions?: StructureUserPermissionDto[];
  uuid?: string;
  workflowTechnologyId?: number;
  workflowTechnologyName?: string;
  workingData?: string;
};
export type ApiNodeColumnSource = "API_NODE" | "ROW_SET" | "TABLE";
export type ApiNodeColumnDto = {
  columnCode?: string;
  columnName?: string;
  columnUuid?: string;
  sourceStructureCode?: string;
  sourceStructureId?: number;
  sourceType?: ApiNodeColumnSource;
};
export type StructureDataDto = {
  data?: string;
  workingData?: string;
};
export type TableDiagramLinkDto = {
  constraintCode?: string;
  constraintName?: string;
  foreignKeyColumnCode?: string;
  foreignKeyColumnCodes?: TableConstraintColumn[];
  foreignKeyTableId?: number;
  primaryKeyColumnCodes?: TableConstraintColumn[];
  primaryKeyTableId?: number;
};
export type TableDiagramNodeRelationship = "DIRECT" | "REFERENCED";
export type TableDiagramNodeDto = {
  code?: string;
  id?: number;
  name?: string;
  relationship?: TableDiagramNodeRelationship;
};
export type TableDiagramDto = {
  links?: TableDiagramLinkDto[];
  nodes?: TableDiagramNodeDto[];
  tableDirectIds?: number[];
  tableReferencedIds?: number[];
};
export type TemplateListDto = {
  author?: UserInfoDto;
  comment?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDto;
  objectSettings?: ReferenceObjectInfo;
  stereotype?: ReferenceObjectInfo;
  structureType?: StructureType;
  technology: ReferenceObjectInfo;
};
export type TemplateListDtoRead = {
  author?: UserInfoDtoRead;
  comment?: string;
  created?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  lockTime?: string;
  lockedBy?: UserInfoDtoRead;
  objectSettings?: ReferenceObjectInfoRead;
  stereotype?: ReferenceObjectInfoRead;
  structureType?: StructureType;
  technology: ReferenceObjectInfoRead;
  version?: number;
};
export type GeneratedSqlDto = {
  errors?: string[];
  fileName?: string;
  formatType?: FormatType;
  objectSettingsCode?: string;
  sql: string;
  sqlType: SqlType;
  structureHistoryId: number;
  structurePath?: string;
  template: TemplateListDto;
  templateDataMap?: {
    [key: string]: any;
  };
};
export type GeneratedSqlDtoRead = {
  errors?: string[];
  fileName?: string;
  formatType?: FormatType;
  objectSettingsCode?: string;
  sql: string;
  sqlType: SqlType;
  structureHistoryId: number;
  structurePath?: string;
  template: TemplateListDtoRead;
  templateDataMap?: {
    [key: string]: any;
  };
};
export type StructureExport = {
  content?: StructureExportDto;
  exportFileName?: string;
};
export type HistoryWithDeploymentDto = {
  authorId: number;
  authorName: string;
  created: string;
  deployments?: DeploymentDto[];
  description?: string;
  id: number;
  structureId: number;
  version: number;
};
export type HistoryDto = {
  authorId: number;
  authorName: string;
  created: string;
  description?: string;
  id: number;
  structureId: number;
  version: number;
};
export type NewHistoryDto = {
  description: string;
};
export type HistoryDetailDto = {
  authorId: number;
  authorName: string;
  code?: string;
  created: string;
  data: string;
  deploymentDto?: DeploymentDto;
  description?: string;
  id: number;
  name?: string;
  structureId: number;
  version: number;
};
export type JsonPatch = any;
export type MassUpdateDto = {
  commitMessage?: string;
  patch?: JsonPatch;
  stereotypeType?: StereotypeType;
  structureIds?: number[];
};
export type ReorderStrategy = "ALPHABETICAL" | "CUSTOM" | "TYPE";
export type ReorderStructureDto = {
  enterBeforeStructureId?: number;
  reorderStrategy?: ReorderStrategy;
  targetParentStructureId?: number;
};
export type PermissionCode =
  | "NO_ACCESS"
  | "READ_ACCESS"
  | "FULL_ACCESS"
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "FORCE_UNLOCK";
export type NewStructureUserPermissionBatchDto = {
  permissionCodes: PermissionCode[];
  userId: number;
};
export type NewStructureUserPermissionDto = {
  permissionCode: PermissionCode;
};
export type PrePushValidationType =
  | "BROKEN_LINK"
  | "BROKEN_FK"
  | "MISSING_REQ_FIELD"
  | "MAPPING_COLUMN_CHANGED"
  | "DELETED_COLUMN"
  | "DELETED_IDX"
  | "DELETED_CONSTRAINT"
  | "SOME_EXPECTED_VALUE_MISSING"
  | "SOME_VALUE_REMOVED"
  | "UNIQUE_UUID";
export type PrePushValidationDto = {
  allowedIgnore?: boolean;
  editableByActualUser?: boolean;
  message?: string;
  path?: string;
  structureId?: number;
  structureType?: StructureType;
  type?: PrePushValidationType;
};
export type StructureReferenceDto = {
  code?: string;
  id?: number;
  type?: StructureType;
  uuid?: string;
};
export type RelationCreateDto = {
  code?: string;
  description?: string;
  name?: string;
  rightSideStructure?: StructureReferenceDto;
};
export type TechnologyDto = {
  code: string;
  description: string;
  id: number;
  name: string;
};
export type AutocompleteResultDto = {
  code?: string;
  name?: string;
};
export type AsyncTaskState =
  | "NEW"
  | "RUNNING"
  | "ERROR"
  | "FINISHED"
  | "CANCELLED";
export type AsyncTaskType =
  | "MASS_EXPORT"
  | "UPDATE_TECHNICAL_COLUMNS"
  | "UPDATE_NAMING"
  | "IMPORT_STRUCTURES"
  | "PREVIEW";
export type AsyncTaskExecutionDto = {
  createdAt?: string;
  createdBy?: string;
  errorMessage?: string;
  id?: number;
  itemDone?: number;
  itemTotal?: number;
  /** Progress in % */
  progress?: number;
  state?: AsyncTaskState;
  type?: AsyncTaskType;
  updatedAt?: string;
};
export type PageWrapperAsyncTaskExecutionDto = {
  content?: AsyncTaskExecutionDto[];
  page?: number;
  size?: number;
  totalElements?: number;
  totalPages?: number;
};
export type TechnicalColumnDto = {
  code: string;
  comment?: string;
  description?: string;
  domainId: number;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumnId?: number;
  stereotypeIds?: number[];
  virtualColumnScript?: string;
};
export type TechnicalColumnDtoRead = {
  code: string;
  comment?: string;
  createdAt?: string;
  createdBy?: string;
  deleted?: boolean;
  description?: string;
  domainId: number;
  id?: number;
  name: string;
  notNull?: boolean;
  ordering?: number;
  stereotypeColumnId?: number;
  stereotypeIds?: number[];
  updatedAt?: string;
  updatedBy?: string;
  version?: number;
  virtualColumnScript?: string;
};
export type TemplateListDtoV1 = {
  authorName?: string;
  comment?: string;
  created?: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  objectSettingsId?: number;
  objectSettingsName?: string;
  stereotypeId?: number;
  stereotypeName?: string;
  structureType?: StructureType;
  technologyId: number;
  technologyName?: string;
  version?: number;
};
export type TemplateDtoV1 = {
  authorName?: string;
  comment?: string;
  created?: string;
  data: string;
  description?: string;
  fileExtension?: string;
  formatType?: FormatType;
  id?: number;
  objectSettingsId?: number;
  objectSettingsName?: string;
  stereotypeId?: number;
  stereotypeName?: string;
  structureType?: StructureType;
  technologyId: number;
  technologyName?: string;
  version?: number;
};
export type NewUserDto = {
  department?: string;
  description?: string;
  email: string;
  loginName: string;
  name?: string;
  password: string;
  surname?: string;
  type?: UserType;
};
export type ApiUserDto = {
  clientId?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDto;
  writeAccess?: boolean;
};
export type ApiUserDtoRead = {
  clientId?: string;
  clientSecret?: string;
  description?: string;
  name?: string;
  owner?: UserInfoDtoRead;
  writeAccess?: boolean;
};
export type UserComboDto = {
  id: number;
  value: string;
};
export type SessionContextDto = {
  context?: string;
  user?: UserDto;
};
export type SessionContextDtoRead = {
  context?: string;
  user?: UserDtoRead;
};
export type UserMessageDto = {
  message?: string;
};
export type ResetPasswordDto = {
  username: string;
};
export type EditUserInfoDto = {
  department?: string;
  description?: string;
  email: string;
  loginName: string;
  name: string;
  surname: string;
  type?: UserType;
};
export type RoleEnum =
  | "SUPER_ADMIN"
  | "MANAGE_USERS"
  | "MANAGE_LOV"
  | "CREATE_DELETE_SYSTEM"
  | "EXT_SYSTEM"
  | "EXT_SYSTEM_WRITE"
  | "ADMIN"
  | "READER"
  | "SUPPORT"
  | "MANAGE_TEMPLATES"
  | "MANAGE_CREDENTIALS";
export type UserRolesDto = {
  roles: RoleEnum[];
};
export type UtilsNameRequestDto = {
  name: string;
  systemFolderId?: number;
};
export type CheckResultDto = {
  errors?: string[];
  result: boolean;
};
export type ElementType =
  | "TABLE"
  | "MAPPING"
  | "COLUMN"
  | "VIEW"
  | "FOLDER"
  | "SYSTEM_FOLDER"
  | "RELATION"
  | "OVERVIEW"
  | "CONSTRAINT"
  | "STEREOTYPE";
export type ValidationMessageDto = {
  description: string;
  elementName: string;
  elementType: ElementType;
  id: number;
  message: string;
  nodeName: string;
  nodeType: NodeType;
  path?: string;
  ruleName?: string;
  severity: Severity;
  uuid?: string;
};
export const {
  useGetAcronymsUsingGetQuery,
  useLazyGetAcronymsUsingGetQuery,
  useCreateAcronymUsingPostMutation,
  useDeleteAcronymUsingDeleteMutation,
  useGetAcronymUsingGetQuery,
  useLazyGetAcronymUsingGetQuery,
  useUpdateAcronymUsingPutMutation,
  useGetAuditLogsUsingGetQuery,
  useLazyGetAuditLogsUsingGetQuery,
  useGetAllBusinessDomainsUsingGetQuery,
  useLazyGetAllBusinessDomainsUsingGetQuery,
  useCreateBusinessDomainUsingPostMutation,
  useGetAllBusinessDomainsForComboUsingGetQuery,
  useLazyGetAllBusinessDomainsForComboUsingGetQuery,
  useDeleteBusinessDomainUsingDeleteMutation,
  useGetBusinessDomainUsingGetQuery,
  useLazyGetBusinessDomainUsingGetQuery,
  useUpdateBusinessDomainUsingPutMutation,
  useGetCompanyUsingGetQuery,
  useLazyGetCompanyUsingGetQuery,
  useGetAllCustomAttributeStructureTypeDtoUsingGetQuery,
  useLazyGetAllCustomAttributeStructureTypeDtoUsingGetQuery,
  useGetAllCustomAttributesUsingGetQuery,
  useLazyGetAllCustomAttributesUsingGetQuery,
  useCreateCustomAttributeUsingPostMutation,
  useGetAllCustomAttributesForComboUsingGetQuery,
  useLazyGetAllCustomAttributesForComboUsingGetQuery,
  useDeleteCustomAttributeUsingDeleteMutation,
  useGetCustomAttributeUsingGetQuery,
  useLazyGetCustomAttributeUsingGetQuery,
  useUpdateCustomAttributeUsingPutMutation,
  useGetAllCustomLovsUsingGetQuery,
  useLazyGetAllCustomLovsUsingGetQuery,
  useCreateCustomLovUsingPostMutation,
  useGetAllCustomLovForComboUsingGetQuery,
  useLazyGetAllCustomLovForComboUsingGetQuery,
  useDeleteCustomLovUsingDeleteMutation,
  useGetCustomLovUsingGetQuery,
  useLazyGetCustomLovUsingGetQuery,
  useUpdateCustomLovUsingPutMutation,
  useGetCustomLovForComboByIdUsingGetQuery,
  useLazyGetCustomLovForComboByIdUsingGetQuery,
  useGetAllNodeDeploymentsUsingGetQuery,
  useLazyGetAllNodeDeploymentsUsingGetQuery,
  useGetAllSpDeploymentsUsingGetQuery,
  useLazyGetAllSpDeploymentsUsingGetQuery,
  useCreateDeployUsingPostMutation,
  useGetDeploymentDetailUsingGetQuery,
  useLazyGetDeploymentDetailUsingGetQuery,
  useGetAllDomainsUsingGetQuery,
  useLazyGetAllDomainsUsingGetQuery,
  useCreateDomainUsingPostMutation,
  useGetAllDomainsForComboUsingGetQuery,
  useLazyGetAllDomainsForComboUsingGetQuery,
  useGetAllDomainsFilteredBySystemTechnologyUsingGetQuery,
  useLazyGetAllDomainsFilteredBySystemTechnologyUsingGetQuery,
  useDeleteDomainUsingDeleteMutation,
  useGetAllDomainsFilteredBySystemTechnologyDepUsingGetQuery,
  useLazyGetAllDomainsFilteredBySystemTechnologyDepUsingGetQuery,
  useUpdateDomainUsingPutMutation,
  useGetColumnsByDomainUsingGetQuery,
  useLazyGetColumnsByDomainUsingGetQuery,
  useGetColumnsByDomainCsvUsingGetQuery,
  useLazyGetColumnsByDomainCsvUsingGetQuery,
  useComputeImpactDomainChangeUsingPostMutation,
  useGetEnvironmentsUsingGetQuery,
  useLazyGetEnvironmentsUsingGetQuery,
  useGetEnvironmentsWithLastDeploymentUsingGetQuery,
  useLazyGetEnvironmentsWithLastDeploymentUsingGetQuery,
  useGetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetQuery,
  useLazyGetEnvironmentsWithLastDeploymentPerObjectTypeUsingGetQuery,
  useGetEnvironmentByIdUsingGetQuery,
  useLazyGetEnvironmentByIdUsingGetQuery,
  useCheckFileUsingPostMutation,
  useCheckJsonUsingPostMutation,
  useImportFileUsingPostMutation,
  useImportStructuresUsingPostMutation,
  useGetInitInfoUsingGetQuery,
  useLazyGetInitInfoUsingGetQuery,
  useSyncRolesUsingPostMutation,
  useSyncSupportUsersUsingPostMutation,
  useMgmtCreateTenantUsingPostMutation,
  useGetAllAcronymsUsingGetQuery,
  useLazyGetAllAcronymsUsingGetQuery,
  useImportAcronymsFromFileUsingPostUsingPostMutation,
  useGetCodeListUsingGetQuery,
  useLazyGetCodeListUsingGetQuery,
  useImportCodeListUsingPostUsingPostMutation,
  useGetUsersUsingGet1Query,
  useLazyGetUsersUsingGet1Query,
  useExportTemplatesUsingGetUsingGetQuery,
  useLazyExportTemplatesUsingGetUsingGetQuery,
  useImportTemplatesFromFileUsingPostUsingPostMutation,
  useGetNamingsUsingGetQuery,
  useLazyGetNamingsUsingGetQuery,
  useCreateNamingUsingPostMutation,
  useUpdateNamingsUsingPutMutation,
  useDummyNamingUsingPostMutation,
  useExecuteNamingUsingPostMutation,
  useExecuteNamingOverWorkingDataUsingPostMutation,
  useDeleteNamingUsingDeleteMutation,
  useGetNamingUsingGetQuery,
  useLazyGetNamingUsingGetQuery,
  useGetAllObjectSettingsUsingGetQuery,
  useLazyGetAllObjectSettingsUsingGetQuery,
  useCreateObjectSettingsUsingPostMutation,
  useGetObjectSettingsByTypeUsingGetQuery,
  useLazyGetObjectSettingsByTypeUsingGetQuery,
  useGetAllObjectSettingsForTargetStructureUsingGetQuery,
  useLazyGetAllObjectSettingsForTargetStructureUsingGetQuery,
  useGetUsedObjectSettingsUsingGetQuery,
  useLazyGetUsedObjectSettingsUsingGetQuery,
  useDeleteObjectSettingsUsingDeleteMutation,
  useGetAllObjectSettingsForTargetStructureDepUsingGetQuery,
  useLazyGetAllObjectSettingsForTargetStructureDepUsingGetQuery,
  useUpdateObjectSettingsUsingPutMutation,
  useGetPermissionsUsingGetQuery,
  useLazyGetPermissionsUsingGetQuery,
  useGetAllRelationsByRelationTypeUsingGetQuery,
  useLazyGetAllRelationsByRelationTypeUsingGetQuery,
  useGetStereotypeCategoriesUsingGetQuery,
  useLazyGetStereotypeCategoriesUsingGetQuery,
  useGetStereotypeTypesUsingGetQuery,
  useLazyGetStereotypeTypesUsingGetQuery,
  useGetStereotypeTypesForObjectSettingsUsingGetQuery,
  useLazyGetStereotypeTypesForObjectSettingsUsingGetQuery,
  useGetStereotypesUsingGetQuery,
  useLazyGetStereotypesUsingGetQuery,
  useCreateStereotypeUsingPostMutation,
  useGetStereotypesForTemplatesUsingGetQuery,
  useLazyGetStereotypesForTemplatesUsingGetQuery,
  useGetStereotypesForTableTemplatesUsingGetQuery,
  useLazyGetStereotypesForTableTemplatesUsingGetQuery,
  useDeleteStereotypeUsingDeleteMutation,
  useUpdateStereotypeUsingPutMutation,
  useGetSubStereotypesUsingGetQuery,
  useLazyGetSubStereotypesUsingGetQuery,
  useGetRootNodesUsingGetQuery,
  useLazyGetRootNodesUsingGetQuery,
  useCreateNodeUsingPostMutation,
  useGetAllStructureTypeDtoUsingGetQuery,
  useLazyGetAllStructureTypeDtoUsingGetQuery,
  useSearchFullTextUsingGetQuery,
  useLazySearchFullTextUsingGetQuery,
  useSearchFullTextJsonUsingGetQuery,
  useLazySearchFullTextJsonUsingGetQuery,
  useImportStructureFileUsingPostMutation,
  useImportStructureFileIntoNodeUsingPostMutation,
  useImportStructureCsvIntoNodeUsingPostMutation,
  useImportStructureCsvIntoNodeCheckUsingPostMutation,
  useGenerateMassExportFileUsingPostMutation,
  useSearchNodesUsingGetQuery,
  useLazySearchNodesUsingGetQuery,
  useSearchStructureUsingGetQuery,
  useLazySearchStructureUsingGetQuery,
  useGetSystemEnvironmentsUsingGetQuery,
  useLazyGetSystemEnvironmentsUsingGetQuery,
  useResetVersionUsingPostMutation,
  useTakeOverVersionUsingPostMutation,
  useGetSystemReleasesUsingGetQuery,
  useLazyGetSystemReleasesUsingGetQuery,
  useCreateSystemReleaseUsingPostMutation,
  useDeleteSystemReleaseUsingDeleteMutation,
  useGetSystemReleaseUsingGetQuery,
  useLazyGetSystemReleaseUsingGetQuery,
  useUpdateSystemReleaseUsingPutMutation,
  useGetReleaseEnvironmentsUsingGetQuery,
  useLazyGetReleaseEnvironmentsUsingGetQuery,
  useCreateReleaseEnvironmentUsingPostMutation,
  useDeleteReleaseEnvironmentUsingDeleteMutation,
  useUpdateReleaseEnvironmentUsingPutMutation,
  usePushReleaseToGitUsingPostMutation,
  useCreateReleasePreviewUsingPostMutation,
  useCreateReleaseScriptsUsingPostMutation,
  useCreateDeploymentsUsingPostMutation,
  useChangeReleaseStatusUsingPatchMutation,
  useGetReleaseStructuresUsingGetQuery,
  useLazyGetReleaseStructuresUsingGetQuery,
  useAddStructureToReleaseUsingPostMutation,
  useDeleteReleaseStructureUsingDeleteMutation,
  useGetAllTablesForSystemNodeUsingGetQuery,
  useLazyGetAllTablesForSystemNodeUsingGetQuery,
  useGetMappingsOfSystemNodesUsingGetQuery,
  useLazyGetMappingsOfSystemNodesUsingGetQuery,
  useGetWorkflowsOfSystemNodeUsingGetQuery,
  useLazyGetWorkflowsOfSystemNodeUsingGetQuery,
  useDeleteNodeUsingDeleteMutation,
  useGetNodeDetailUsingGetQuery,
  useLazyGetNodeDetailUsingGetQuery,
  useGetApiNodeColumnFromAllStructuresUsingGetQuery,
  useLazyGetApiNodeColumnFromAllStructuresUsingGetQuery,
  useGetNodesOfSpecificParentUsingGetQuery,
  useLazyGetNodesOfSpecificParentUsingGetQuery,
  useCreateChildNodeUsingPostMutation,
  useImportColumnsFromCsvUsingPostMutation,
  useImportColumnsFromCsvCheckUsingPostMutation,
  useDeleteDataNodeUsingDeleteMutation,
  useEditDataNodeUsingGetQuery,
  useLazyEditDataNodeUsingGetQuery,
  useUpdateDataNodeUsingPutMutation,
  useGetDiagramUsingGetQuery,
  useLazyGetDiagramUsingGetQuery,
  useGetDeepDiagramUsingGetQuery,
  useLazyGetDeepDiagramUsingGetQuery,
  useCreateFromSystemStructureUsingGetQuery,
  useLazyCreateFromSystemStructureUsingGetQuery,
  useGetDiagramFromRelationUsingGetQuery,
  useLazyGetDiagramFromRelationUsingGetQuery,
  useDuplicateNodeUsingPostMutation,
  useDuplicateNodeRecursiveUsingPostMutation,
  useGenerateAndPushToGitUsingGetQuery,
  useLazyGenerateAndPushToGitUsingGetQuery,
  useGenerateSqlPreviewEnvironmentUsingGetQuery,
  useLazyGenerateSqlPreviewEnvironmentUsingGetQuery,
  useGenerateSqlUsingGetQuery,
  useLazyGenerateSqlUsingGetQuery,
  useGenerateSqlDownloadZipFileUsingGetQuery,
  useLazyGenerateSqlDownloadZipFileUsingGetQuery,
  useExportStructureUsingGetQuery,
  useLazyExportStructureUsingGetQuery,
  useGetAllNodeHistoryUsingGetQuery,
  useLazyGetAllNodeHistoryUsingGetQuery,
  useCreateNodeHistoryUsingPostMutation,
  useGetNodeHistoryDetailByVersionUsingGetQuery,
  useLazyGetNodeHistoryDetailByVersionUsingGetQuery,
  useDeleteNodeHistoryUsingDeleteMutation,
  useGetNodeHistoryDetailUsingGetQuery,
  useLazyGetNodeHistoryDetailUsingGetQuery,
  useDeleteNodeLockUsingDeleteMutation,
  useCreateNodeLockUsingPostMutation,
  useGetMappingsUsingGetQuery,
  useLazyGetMappingsUsingGetQuery,
  useGenerateMassExportPushGitUsingPostMutation,
  useMassPatchStructuresListUsingPatchMutation,
  useMoveNodeUsingPutMutation,
  useReorderNodeUsingPutMutation,
  usePatchMergeStructuresUsingPatchMutation,
  useGetStructurePermissionsUsingGetQuery,
  useLazyGetStructurePermissionsUsingGetQuery,
  useUpdateBatchEnvironmentsUsingPutMutation,
  useDeleteUserPermissionUsingDeleteMutation,
  useGetUserPermissionUsingGetQuery,
  useLazyGetUserPermissionUsingGetQuery,
  useChangeUserPermissionUsingPutMutation,
  usePrePushValidationUsingGetQuery,
  useLazyPrePushValidationUsingGetQuery,
  useGetNodeRelationsUsingGetQuery,
  useLazyGetNodeRelationsUsingGetQuery,
  useCreateRelationUsingPostMutation,
  useDeleteRelationUsingDeleteMutation,
  usePathRelationUsingPatchMutation,
  useUpdateRelationUsingPutMutation,
  useGenerateSqlPreviewUsingGetQuery,
  useLazyGenerateSqlPreviewUsingGetQuery,
  useGenerateSqlPreviewDownloadZipFileUsingGetQuery,
  useLazyGenerateSqlPreviewDownloadZipFileUsingGetQuery,
  useGetExistingStructuresForSourceMappingUsingGetQuery,
  useLazyGetExistingStructuresForSourceMappingUsingGetQuery,
  useGetAvailableStructureForSourceObjectUsingGetQuery,
  useLazyGetAvailableStructureForSourceObjectUsingGetQuery,
  useGetSystemUsersUsingGetQuery,
  useLazyGetSystemUsersUsingGetQuery,
  useGetSystemUserUsingGetQuery,
  useLazyGetSystemUserUsingGetQuery,
  useGetUniversalColumnFromAllStructuresUsingGetQuery,
  useLazyGetUniversalColumnFromAllStructuresUsingGetQuery,
  useGetWriteColumnFromAllStructuresUsingGetQuery,
  useLazyGetWriteColumnFromAllStructuresUsingGetQuery,
  useGetAllSystemTechnologiesUsingGetQuery,
  useLazyGetAllSystemTechnologiesUsingGetQuery,
  useSearchTableColumnsUsingGetQuery,
  useLazySearchTableColumnsUsingGetQuery,
  useSearchNodesWithTypeUsingGetQuery,
  useLazySearchNodesWithTypeUsingGetQuery,
  useGetAsyncTasksUsingGetQuery,
  useLazyGetAsyncTasksUsingGetQuery,
  useGetAsyncTasksByStructuredIdUsingGetQuery,
  useLazyGetAsyncTasksByStructuredIdUsingGetQuery,
  useCreateUsingPostMutation,
  useCancelTaskUsingDeleteMutation,
  useGetTaskExecutionUsingGetQuery,
  useLazyGetTaskExecutionUsingGetQuery,
  useGetTaskResultFileUsingGetQuery,
  useLazyGetTaskResultFileUsingGetQuery,
  useGetTaskResultUsingGetQuery,
  useLazyGetTaskResultUsingGetQuery,
  useGetAllTechnicalColumnsUsingGetQuery,
  useLazyGetAllTechnicalColumnsUsingGetQuery,
  useCreateTechnicalColumnUsingPostMutation,
  useGetTechnicalColumnStereotypeUsingGetQuery,
  useLazyGetTechnicalColumnStereotypeUsingGetQuery,
  useDeleteTechnicalColumnUsingDeleteMutation,
  useUpdateTechnicalColumnUsingPutMutation,
  useComputeImpactTcChangeUsingPostMutation,
  useGetTablesByTechnicalColumnUsingGetQuery,
  useLazyGetTablesByTechnicalColumnUsingGetQuery,
  useGetTablesByTechnicalColumnCsvUsingGetQuery,
  useLazyGetTablesByTechnicalColumnCsvUsingGetQuery,
  useGetAllTechnologiesUsingGetQuery,
  useLazyGetAllTechnologiesUsingGetQuery,
  useGetAllTemplatesV1UsingGetQuery,
  useLazyGetAllTemplatesV1UsingGetQuery,
  useCreateTemplateV1UsingPostMutation,
  useDeleteTemplateV1UsingDeleteMutation,
  useGetTemplateV1UsingGetQuery,
  useLazyGetTemplateV1UsingGetQuery,
  useUpdateTemplateV1UsingPutMutation,
  useGetTemplateHistoryV1UsingGetQuery,
  useLazyGetTemplateHistoryV1UsingGetQuery,
  useGetTemplateHistoryDetailV1UsingGetQuery,
  useLazyGetTemplateHistoryDetailV1UsingGetQuery,
  useGetUsersUsingGetQuery,
  useLazyGetUsersUsingGetQuery,
  useAddUserUsingPostMutation,
  useGetApiUsersUsingGetQuery,
  useLazyGetApiUsersUsingGetQuery,
  useAddApiUserUsingPostMutation,
  useDeleteApiUserUsingDeleteMutation,
  useApiUserUpdateUsingPostMutation,
  useApiUserResetSecretUsingPostMutation,
  useGetUsersForComboUsingGetQuery,
  useLazyGetUsersForComboUsingGetQuery,
  useGetSessionContextUsingGetQuery,
  useLazyGetSessionContextUsingGetQuery,
  useUpdateSessionContextUsingPutMutation,
  useLockUserUsingPostMutation,
  useResetUserPasswordUsingPostMutation,
  useUnlockUserUsingPostMutation,
  useDeleteUserUsingDeleteMutation,
  useGetUserUsingGetQuery,
  useLazyGetUserUsingGetQuery,
  useEditUserUsingPutMutation,
  useGetUserRolesUsingGetQuery,
  useLazyGetUserRolesUsingGetQuery,
  useEditUserRolesUsingPutMutation,
  useAdjustTableNameUsingPostMutation,
  useCheckUniqueNameUsingPostMutation,
  useCheckStructureUsingGetQuery,
  useLazyCheckStructureUsingGetQuery,
  useGetAllWorkflowTechnologiesUsingGetQuery,
  useLazyGetAllWorkflowTechnologiesUsingGetQuery,
} = injectedRtkApi;
